// Automatically generated with Reach 0.1.8 (dab71275)
/* eslint-disable */
export const _version = '0.1.8';
export const _versionHash = '0.1.8 (dab71275)';
export const _backendVersion = 7;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc4 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc5 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc5
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v860;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v860;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endSecs: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              return (await ((async () => {
                
                
                return v796;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v796;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v796;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        floorPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              return (await ((async () => {
                
                
                return v795;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v795;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v795;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        priceChangePerSec: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v859;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v859;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        startPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              return (await ((async () => {
                
                
                return v794;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v794;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v794;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v718, v719, v723, v724, v730] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v719, v724, v764] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 3))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824] = svs;
              return (await ((async () => {
                
                
                return v793;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5))) {
              const [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v793;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = svs;
              return (await ((async () => {
                
                
                return v793;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc1, ctc2, ctc0],
      2: [ctc0, ctc2, ctc1],
      3: [ctc2, ctc0, ctc2, ctc1, ctc1, ctc1, ctc3, ctc4, ctc1, ctc1, ctc1, ctc0],
      5: [ctc2, ctc2, ctc1, ctc1, ctc1, ctc3, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1],
      7: [ctc2, ctc0, ctc2, ctc1, ctc1, ctc1, ctc3, ctc4, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 32));
  const ctc4 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8));
  const ctc5 = stdlib.T_Data({
    Contractee0_59: ctc1,
    Verifier0_59: ctc1
    });
  const ctc6 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc7 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc8 = stdlib.T_Object({
    addrs: ctc6,
    creator: ctc0,
    distr: ctc7,
    endSecs: ctc1,
    floorPrice: ctc1,
    royaltyCap: ctc1,
    startPrice: ctc1,
    token: ctc2
    });
  const ctc9 = stdlib.T_Null;
  const ctc10 = stdlib.T_Tuple([]);
  const ctc11 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc10,
    Bid_cancel0_273: ctc10,
    Bid_touch0_273: ctc10
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 9,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
  ;
  ;
  const v730 = v718;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 1,
    funcNum: 1,
    out_tys: [ctc5],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
  switch (v747[0]) {
    case 'Contractee0_59': {
      const v750 = v747[1];
      ;
      v746;
      const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
      stdlib.assert(v760, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v764 = stdlib.sub(v723, v723);
      ;
      const v771 = stdlib.protect(ctc8, await interact.getParams(), {
        at: './interface.rsh:135:25:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'getParams',
        who: 'Auctioneer'
        });
      const v772 = v771.token;
      const v773 = v771.startPrice;
      const v774 = v771.floorPrice;
      const v775 = v771.endSecs;
      const v776 = v771.addrs;
      const v777 = v771.distr;
      const v778 = v771.royaltyCap;
      const v779 = stdlib.gt(v774, stdlib.checkedBigNumberify('./interface.rsh:137:25:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v779, {
        at: './interface.rsh:137:11:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v780 = stdlib.lt(v774, v773);
      stdlib.assert(v780, {
        at: './interface.rsh:138:11:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v781 = stdlib.tokenEq(v724, v772);
      const v782 = v781 ? false : true;
      stdlib.assert(v782, {
        at: './interface.rsh:139:11:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v783 = stdlib.gt(v775, stdlib.checkedBigNumberify('./interface.rsh:140:22:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v783, {
        at: './interface.rsh:140:11:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v784 = v777.reduce((v785, v786) => {
        const v787 = stdlib.add(v785, v786);
        
        return v787;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v788 = stdlib.le(v784, v778);
      stdlib.assert(v788, {
        at: './interface.rsh:141:11:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v789 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:142:26:decimal', stdlib.UInt_max, 10), v774);
      const v790 = stdlib.div(v789, stdlib.checkedBigNumberify('./interface.rsh:142:44:decimal', stdlib.UInt_max, 1000000));
      const v791 = stdlib.eq(v778, v790);
      stdlib.assert(v791, {
        at: './interface.rsh:142:11:application',
        fs: ['at ./interface.rsh:133:18:application call to [unknown function] (defined at: ./interface.rsh:133:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      
      const txn3 = await (ctc.sendrecv({
        args: [v719, v724, v764, v772, v773, v774, v775, v776, v777, v778],
        evt_cnt: 7,
        funcNum: 2,
        lct: v748,
        onlyIf: true,
        out_tys: [ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1],
        pay: [stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000), []],
        sim_p: (async (txn3) => {
          const sim_r = { txns: [], mapRefs: [], maps: [] };
          
          const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
          
          const v802 = stdlib.tokenEq(v793, v724);
          const v803 = v802 ? false : true;
          stdlib.assert(v803, {
            at: './interface.rsh:144:14:dot',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: 'non-network tokens distinct',
            who: 'Auctioneer'
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
            kind: 'init',
            tok: v793
            });
          const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000),
            kind: 'to',
            tok: undefined
            });
          const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
          stdlib.assert(v806, {
            at: './interface.rsh:147:10:application',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Auctioneer'
            });
          const v807 = stdlib.lt(v795, v794);
          stdlib.assert(v807, {
            at: './interface.rsh:148:10:application',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Auctioneer'
            });
          const v808 = stdlib.tokenEq(v724, v793);
          const v809 = v808 ? false : true;
          stdlib.assert(v809, {
            at: './interface.rsh:149:10:application',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Auctioneer'
            });
          const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
          stdlib.assert(v810, {
            at: './interface.rsh:150:10:application',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Auctioneer'
            });
          const v811 = v798.reduce((v812, v813) => {
            const v814 = stdlib.add(v812, v813);
            
            return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
          const v815 = stdlib.le(v811, v799);
          stdlib.assert(v815, {
            at: './interface.rsh:151:10:application',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Auctioneer'
            });
          const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
          const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
          const v818 = stdlib.eq(v799, v817);
          stdlib.assert(v818, {
            at: './interface.rsh:152:10:application',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Auctioneer'
            });
          
          const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000),
            kind: 'from',
            to: v719,
            tok: undefined
            });
          const v824 = v792;
          sim_r.isHalt = false;
          
          return sim_r;
          }),
        soloSend: true,
        timeoutAt: undefined,
        tys: [ctc0, ctc2, ctc1, ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1],
        waitIfNotPresent: false
        }));
      const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
      const v802 = stdlib.tokenEq(v793, v724);
      const v803 = v802 ? false : true;
      stdlib.assert(v803, {
        at: './interface.rsh:144:14:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'non-network tokens distinct',
        who: 'Auctioneer'
        });
      ;
      const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
      ;
      const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v806, {
        at: './interface.rsh:147:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v807 = stdlib.lt(v795, v794);
      stdlib.assert(v807, {
        at: './interface.rsh:148:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v808 = stdlib.tokenEq(v724, v793);
      const v809 = v808 ? false : true;
      stdlib.assert(v809, {
        at: './interface.rsh:149:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v810, {
        at: './interface.rsh:150:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v811 = v798.reduce((v812, v813) => {
        const v814 = stdlib.add(v812, v813);
        
        return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v815 = stdlib.le(v811, v799);
      stdlib.assert(v815, {
        at: './interface.rsh:151:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
      const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
      const v818 = stdlib.eq(v799, v817);
      stdlib.assert(v818, {
        at: './interface.rsh:152:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      stdlib.protect(ctc9, await interact.signal(), {
        at: './interface.rsh:175:40:application',
        fs: ['at ./interface.rsh:175:18:application call to [unknown function] (defined at: ./interface.rsh:175:22:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'signal',
        who: 'Auctioneer'
        });
      
      const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
      ;
      const v824 = v792;
      const txn4 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 3,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
      ;
      ;
      const v831 = stdlib.addressEq(v824, v825);
      stdlib.assert(v831, {
        at: './interface.rsh:185:13:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'sender correct',
        who: 'Auctioneer'
        });
      const v836 = stdlib.sub(v794, v795);
      const v837 = stdlib.sub(v796, v801);
      const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v850 = stdlib.div(v845, v837);
      const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      let v860 = v794;
      let v861 = true;
      let v862 = v826;
      let v865 = v827;
      let v868 = v823;
      let v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
      let v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
      
      while (await (async () => {
        
        return v861;})()) {
        const txn5 = await (ctc.recv({
          didSend: false,
          evt_cnt: 1,
          funcNum: 6,
          out_tys: [ctc11],
          timeoutAt: undefined,
          waitIfNotPresent: false
          }));
        const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn5;
        switch (v909[0]) {
          case 'Bid_acceptOffer0_273': {
            const v912 = v909[1];
            const v918 = stdlib.sub(v865, v801);
            const v919 = stdlib.mul(v918, v850);
            const v920 = stdlib.div(v919, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v922 = stdlib.lt(v920, v836);
            const v923 = v922 ? v920 : v836;
            const v924 = stdlib.le(v794, v923);
            const v925 = stdlib.sub(v794, v923);
            const v926 = v924 ? v795 : v925;
            const v927 = stdlib.gt(v795, v926);
            const v928 = v927 ? v795 : v926;
            const v932 = stdlib.add(v868, v928);
            ;
            undefined;
            const v934 = null;
            await txn5.getOutput('Bid_acceptOffer', 'v934', ctc9, v934);
            const v952 = stdlib.div(v928, v799);
            const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
            const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
            const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
            const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
            const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
            const v962 = stdlib.add(v954, v955);
            const v963 = stdlib.add(v962, v956);
            const v964 = stdlib.add(v963, v957);
            const v965 = stdlib.add(v964, v958);
            const v966 = stdlib.mul(v952, v965);
            const v967 = stdlib.sub(v928, v966);
            const v969 = stdlib.mul(v952, v954);
            const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
            const v974 = stdlib.sub(v932, v969);
            ;
            const v976 = stdlib.mul(v952, v955);
            const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
            const v981 = stdlib.sub(v974, v976);
            ;
            const v985 = stdlib.sub(v981, v967);
            ;
            const v990 = stdlib.sub(v870, v870);
            ;
            const cv860 = v928;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v985;
            const cv869 = v869;
            const cv870 = v990;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_cancel0_273': {
            const v1027 = v909[1];
            ;
            undefined;
            const v1108 = stdlib.addressEq(v908, v792);
            stdlib.assert(v1108, {
              at: './interface.rsh:250:16:application',
              fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Auctioneer'
              });
            const v1109 = null;
            await txn5.getOutput('Bid_cancel', 'v1109', ctc9, v1109);
            const v1119 = stdlib.sub(v870, v870);
            ;
            const cv860 = v860;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v1119;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_touch0_273': {
            const v1142 = v909[1];
            ;
            undefined;
            const v1237 = stdlib.ge(v860, v795);
            stdlib.assert(v1237, {
              at: './interface.rsh:217:16:application',
              fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Auctioneer'
              });
            const v1238 = null;
            await txn5.getOutput('Bid_touch', 'v1238', ctc9, v1238);
            const v1245 = stdlib.sub(v865, v801);
            const v1246 = stdlib.mul(v1245, v850);
            const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v1249 = stdlib.lt(v1247, v836);
            const v1250 = v1249 ? v1247 : v836;
            const v1251 = stdlib.le(v794, v1250);
            const v1252 = stdlib.sub(v794, v1250);
            const v1253 = v1251 ? v795 : v1252;
            const v1254 = stdlib.gt(v795, v1253);
            const v1255 = v1254 ? v795 : v1253;
            const cv860 = v1255;
            const cv861 = true;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v870;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          }
        
        }
      const txn5 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 5,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
      ;
      const v1261 = stdlib.div(v860, v799);
      const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v1269 = stdlib.add(v1263, v1264);
      const v1270 = stdlib.add(v1269, v1265);
      const v1272 = stdlib.mul(v1261, v1270);
      const v1273 = stdlib.sub(v868, v1272);
      const v1275 = stdlib.mul(v1261, v1263);
      const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
      ;
      const v1282 = stdlib.mul(v1261, v1264);
      const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
      ;
      const v1289 = stdlib.mul(v1261, v1265);
      const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
      ;
      const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
      ;
      ;
      ;
      return;
      
      
      
      
      
      
      
      break;
      }
    case 'Verifier0_59': {
      const v1327 = v747[1];
      ;
      const v1896 = stdlib.addressEq(v746, v730);
      stdlib.assert(v1896, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
      const v1898 = stdlib.addressEq(v746, v718);
      const v1899 = v1897 ? v1898 : false;
      stdlib.assert(v1899, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Auctioneer'
        });
      return;
      
      break;
      }
    }
  
  
  
  };
export async function Bid_acceptOffer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_acceptOffer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_acceptOffer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Token;
  const ctc1 = stdlib.T_Address;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc4 = stdlib.T_Array(ctc2, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc5 = stdlib.T_Tuple([]);
  const ctc6 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc5,
    Bid_cancel0_273: ctc5,
    Bid_touch0_273: ctc5
    });
  const ctc7 = stdlib.T_Null;
  
  
  const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7), [ctc0, ctc1, ctc0, ctc2, ctc2, ctc2, ctc3, ctc4, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2]);
  const v882 = stdlib.protect(ctc5, await interact.in(), {
    at: './interface.rsh:1:23:application',
    fs: ['at ./interface.rsh:227:10:application call to [unknown function] (defined at: ./interface.rsh:227:10:function exp)', 'at ./interface.rsh:206:51:application call to "runBid_acceptOffer0_273" (defined at: ./interface.rsh:225:9:function exp)', 'at ./interface.rsh:206:51:application call to [unknown function] (defined at: ./interface.rsh:206:51:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
    msg: 'in',
    who: 'Bid_acceptOffer'
    });
  
  const v893 = ['Bid_acceptOffer0_273', v882];
  const v895 = stdlib.sub(v865, v801);
  const v896 = stdlib.mul(v895, v850);
  const v897 = stdlib.div(v896, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
  const v899 = stdlib.lt(v897, v836);
  const v900 = v899 ? v897 : v836;
  const v901 = stdlib.le(v794, v900);
  const v902 = stdlib.sub(v794, v900);
  const v903 = v901 ? v795 : v902;
  const v904 = stdlib.gt(v795, v903);
  const v905 = v904 ? v795 : v903;
  
  const txn1 = await (ctc.sendrecv({
    args: [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870, v893],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [v905, []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn1;
      
      switch (v909[0]) {
        case 'Bid_acceptOffer0_273': {
          const v912 = v909[1];
          const v932 = stdlib.add(v868, v905);
          sim_r.txns.push({
            amt: v905,
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v934 = null;
          const v935 = await txn1.getOutput('Bid_acceptOffer', 'v934', ctc7, v934);
          
          const v952 = stdlib.div(v905, v799);
          const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
          const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
          const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
          const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
          const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
          const v962 = stdlib.add(v954, v955);
          const v963 = stdlib.add(v962, v956);
          const v964 = stdlib.add(v963, v957);
          const v965 = stdlib.add(v964, v958);
          const v966 = stdlib.mul(v952, v965);
          const v967 = stdlib.sub(v905, v966);
          const v969 = stdlib.mul(v952, v954);
          const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
          const v974 = stdlib.sub(v932, v969);
          sim_r.txns.push({
            amt: v969,
            kind: 'from',
            to: v970,
            tok: undefined
            });
          const v976 = stdlib.mul(v952, v955);
          const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
          const v981 = stdlib.sub(v974, v976);
          sim_r.txns.push({
            amt: v976,
            kind: 'from',
            to: v977,
            tok: undefined
            });
          const v985 = stdlib.sub(v981, v967);
          sim_r.txns.push({
            amt: v967,
            kind: 'from',
            to: v792,
            tok: undefined
            });
          const v990 = stdlib.sub(v870, v870);
          sim_r.txns.push({
            amt: v870,
            kind: 'from',
            to: v908,
            tok: v793
            });
          const v3078 = v905;
          const v3082 = v985;
          const v3083 = v869;
          const v3084 = v990;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_cancel0_273': {
          const v1027 = v909[1];
          
          break;
          }
        case 'Bid_touch0_273': {
          const v1142 = v909[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc1, ctc0, ctc2, ctc2, ctc2, ctc3, ctc4, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn1;
  switch (v909[0]) {
    case 'Bid_acceptOffer0_273': {
      const v912 = v909[1];
      const v932 = stdlib.add(v868, v905);
      ;
      undefined;
      const v934 = null;
      const v935 = await txn1.getOutput('Bid_acceptOffer', 'v934', ctc7, v934);
      if (v469) {
        stdlib.protect(ctc7, await interact.out(v912, v935), {
          at: './interface.rsh:226:7:application',
          fs: ['at ./interface.rsh:226:7:application call to [unknown function] (defined at: ./interface.rsh:226:7:function exp)', 'at ./interface.rsh:231:10:application call to "k" (defined at: ./interface.rsh:229:11:function exp)', 'at ./interface.rsh:229:11:application call to [unknown function] (defined at: ./interface.rsh:229:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
          msg: 'out',
          who: 'Bid_acceptOffer'
          });
        }
      else {
        }
      
      const v952 = stdlib.div(v905, v799);
      const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
      const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
      const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v962 = stdlib.add(v954, v955);
      const v963 = stdlib.add(v962, v956);
      const v964 = stdlib.add(v963, v957);
      const v965 = stdlib.add(v964, v958);
      const v966 = stdlib.mul(v952, v965);
      const v967 = stdlib.sub(v905, v966);
      const v969 = stdlib.mul(v952, v954);
      const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
      const v974 = stdlib.sub(v932, v969);
      ;
      const v976 = stdlib.mul(v952, v955);
      const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
      const v981 = stdlib.sub(v974, v976);
      ;
      const v985 = stdlib.sub(v981, v967);
      ;
      const v990 = stdlib.sub(v870, v870);
      ;
      const v3078 = v905;
      const v3082 = v985;
      const v3083 = v869;
      const v3084 = v990;
      return;
      
      break;
      }
    case 'Bid_cancel0_273': {
      const v1027 = v909[1];
      return;
      break;
      }
    case 'Bid_touch0_273': {
      const v1142 = v909[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_cancel(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_cancel expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_cancel expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Token;
  const ctc1 = stdlib.T_Address;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc4 = stdlib.T_Array(ctc2, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc5 = stdlib.T_Tuple([]);
  const ctc6 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc5,
    Bid_cancel0_273: ctc5,
    Bid_touch0_273: ctc5
    });
  const ctc7 = stdlib.T_Null;
  
  
  const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7), [ctc0, ctc1, ctc0, ctc2, ctc2, ctc2, ctc3, ctc4, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2]);
  const v886 = ctc.selfAddress();
  const v888 = stdlib.protect(ctc5, await interact.in(), {
    at: './interface.rsh:1:23:application',
    fs: ['at ./interface.rsh:247:10:application call to [unknown function] (defined at: ./interface.rsh:247:10:function exp)', 'at ./interface.rsh:206:51:application call to "runBid_cancel0_273" (defined at: ./interface.rsh:245:9:function exp)', 'at ./interface.rsh:206:51:application call to [unknown function] (defined at: ./interface.rsh:206:51:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
    msg: 'in',
    who: 'Bid_cancel'
    });
  const v889 = stdlib.addressEq(v886, v792);
  stdlib.assert(v889, {
    at: './interface.rsh:247:19:application',
    fs: ['at ./interface.rsh:247:10:application call to [unknown function] (defined at: ./interface.rsh:247:10:function exp)', 'at ./interface.rsh:247:10:application call to [unknown function] (defined at: ./interface.rsh:247:10:function exp)', 'at ./interface.rsh:206:51:application call to "runBid_cancel0_273" (defined at: ./interface.rsh:245:9:function exp)', 'at ./interface.rsh:206:51:application call to [unknown function] (defined at: ./interface.rsh:206:51:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
    msg: null,
    who: 'Bid_cancel'
    });
  
  const v906 = ['Bid_cancel0_273', v888];
  
  const txn1 = await (ctc.sendrecv({
    args: [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870, v906],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./interface.rsh:248:13:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn1;
      
      switch (v909[0]) {
        case 'Bid_acceptOffer0_273': {
          const v912 = v909[1];
          
          break;
          }
        case 'Bid_cancel0_273': {
          const v1027 = v909[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:248:13:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          undefined;
          const v1108 = stdlib.addressEq(v908, v792);
          stdlib.assert(v1108, {
            at: './interface.rsh:250:16:application',
            fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Bid_cancel'
            });
          const v1109 = null;
          const v1110 = await txn1.getOutput('Bid_cancel', 'v1109', ctc7, v1109);
          
          const v1119 = stdlib.sub(v870, v870);
          sim_r.txns.push({
            amt: v870,
            kind: 'from',
            to: v908,
            tok: v793
            });
          const v3182 = v860;
          const v3186 = v868;
          const v3187 = v869;
          const v3188 = v1119;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_touch0_273': {
          const v1142 = v909[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc1, ctc0, ctc2, ctc2, ctc2, ctc3, ctc4, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn1;
  switch (v909[0]) {
    case 'Bid_acceptOffer0_273': {
      const v912 = v909[1];
      return;
      break;
      }
    case 'Bid_cancel0_273': {
      const v1027 = v909[1];
      ;
      undefined;
      const v1108 = stdlib.addressEq(v908, v792);
      stdlib.assert(v1108, {
        at: './interface.rsh:250:16:application',
        fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Bid_cancel'
        });
      const v1109 = null;
      const v1110 = await txn1.getOutput('Bid_cancel', 'v1109', ctc7, v1109);
      if (v469) {
        stdlib.protect(ctc7, await interact.out(v1027, v1110), {
          at: './interface.rsh:246:7:application',
          fs: ['at ./interface.rsh:246:7:application call to [unknown function] (defined at: ./interface.rsh:246:7:function exp)', 'at ./interface.rsh:251:10:application call to "k" (defined at: ./interface.rsh:249:11:function exp)', 'at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
          msg: 'out',
          who: 'Bid_cancel'
          });
        }
      else {
        }
      
      const v1119 = stdlib.sub(v870, v870);
      ;
      const v3182 = v860;
      const v3186 = v868;
      const v3187 = v869;
      const v3188 = v1119;
      return;
      
      break;
      }
    case 'Bid_touch0_273': {
      const v1142 = v909[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_touch(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Token;
  const ctc1 = stdlib.T_Address;
  const ctc2 = stdlib.T_UInt;
  const ctc3 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc4 = stdlib.T_Array(ctc2, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc5 = stdlib.T_Tuple([]);
  const ctc6 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc5,
    Bid_cancel0_273: ctc5,
    Bid_touch0_273: ctc5
    });
  const ctc7 = stdlib.T_Null;
  
  
  const [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7), [ctc0, ctc1, ctc0, ctc2, ctc2, ctc2, ctc3, ctc4, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2]);
  const v875 = stdlib.protect(ctc5, await interact.in(), {
    at: './interface.rsh:1:23:application',
    fs: ['at ./interface.rsh:214:10:application call to [unknown function] (defined at: ./interface.rsh:214:10:function exp)', 'at ./interface.rsh:206:51:application call to "runBid_touch0_273" (defined at: ./interface.rsh:212:9:function exp)', 'at ./interface.rsh:206:51:application call to [unknown function] (defined at: ./interface.rsh:206:51:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
    msg: 'in',
    who: 'Bid_touch'
    });
  const v876 = stdlib.ge(v860, v795);
  stdlib.assert(v876, {
    at: './interface.rsh:214:19:application',
    fs: ['at ./interface.rsh:214:10:application call to [unknown function] (defined at: ./interface.rsh:214:10:function exp)', 'at ./interface.rsh:214:10:application call to [unknown function] (defined at: ./interface.rsh:214:10:function exp)', 'at ./interface.rsh:206:51:application call to "runBid_touch0_273" (defined at: ./interface.rsh:212:9:function exp)', 'at ./interface.rsh:206:51:application call to [unknown function] (defined at: ./interface.rsh:206:51:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
    msg: null,
    who: 'Bid_touch'
    });
  
  const v907 = ['Bid_touch0_273', v875];
  
  const txn1 = await (ctc.sendrecv({
    args: [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v836, v850, v859, v860, v865, v868, v869, v870, v907],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./interface.rsh:215:13:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn1;
      
      switch (v909[0]) {
        case 'Bid_acceptOffer0_273': {
          const v912 = v909[1];
          
          break;
          }
        case 'Bid_cancel0_273': {
          const v1027 = v909[1];
          
          break;
          }
        case 'Bid_touch0_273': {
          const v1142 = v909[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:215:13:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          undefined;
          stdlib.assert(v876, {
            at: './interface.rsh:217:16:application',
            fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: null,
            who: 'Bid_touch'
            });
          const v1238 = null;
          const v1239 = await txn1.getOutput('Bid_touch', 'v1238', ctc7, v1238);
          
          const v1245 = stdlib.sub(v865, v801);
          const v1246 = stdlib.mul(v1245, v850);
          const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
          const v1249 = stdlib.lt(v1247, v836);
          const v1250 = v1249 ? v1247 : v836;
          const v1251 = stdlib.le(v794, v1250);
          const v1252 = stdlib.sub(v794, v1250);
          const v1253 = v1251 ? v795 : v1252;
          const v1254 = stdlib.gt(v795, v1253);
          const v1255 = v1254 ? v795 : v1253;
          const v3286 = v1255;
          const v3289 = v911;
          const v3290 = v868;
          const v3291 = v869;
          const v3292 = v870;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc1, ctc0, ctc2, ctc2, ctc2, ctc3, ctc4, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc2, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn1;
  switch (v909[0]) {
    case 'Bid_acceptOffer0_273': {
      const v912 = v909[1];
      return;
      break;
      }
    case 'Bid_cancel0_273': {
      const v1027 = v909[1];
      return;
      break;
      }
    case 'Bid_touch0_273': {
      const v1142 = v909[1];
      ;
      undefined;
      stdlib.assert(v876, {
        at: './interface.rsh:217:16:application',
        fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Bid_touch'
        });
      const v1238 = null;
      const v1239 = await txn1.getOutput('Bid_touch', 'v1238', ctc7, v1238);
      if (v469) {
        stdlib.protect(ctc7, await interact.out(v1142, v1239), {
          at: './interface.rsh:213:7:application',
          fs: ['at ./interface.rsh:213:7:application call to [unknown function] (defined at: ./interface.rsh:213:7:function exp)', 'at ./interface.rsh:218:10:application call to "k" (defined at: ./interface.rsh:216:11:function exp)', 'at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
          msg: 'out',
          who: 'Bid_touch'
          });
        }
      else {
        }
      
      const v1245 = stdlib.sub(v865, v801);
      const v1246 = stdlib.mul(v1245, v850);
      const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v1249 = stdlib.lt(v1247, v836);
      const v1250 = v1249 ? v1247 : v836;
      const v1251 = stdlib.le(v794, v1250);
      const v1252 = stdlib.sub(v794, v1250);
      const v1253 = v1251 ? v795 : v1252;
      const v1254 = stdlib.gt(v795, v1253);
      const v1255 = v1254 ? v795 : v1253;
      const v3286 = v1255;
      const v3289 = v911;
      const v3290 = v868;
      const v3291 = v869;
      const v3292 = v870;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 32));
  const ctc4 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8));
  const ctc5 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0,
    addr5: ctc0,
    amt: ctc1,
    tok: ctc2,
    token_name: ctc3,
    token_symbol: ctc4
    });
  const ctc6 = stdlib.T_Null;
  const ctc7 = stdlib.T_Data({
    Contractee0_59: ctc1,
    Verifier0_59: ctc1
    });
  const ctc8 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc9 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc10 = stdlib.T_Tuple([]);
  const ctc11 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc10,
    Bid_cancel0_273: ctc10,
    Bid_touch0_273: ctc10
    });
  
  
  const v707 = stdlib.protect(ctc5, await interact.getParams(), {
    at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:59:38:application',
    fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:44:19:application call to [unknown function] (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:44:23:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:146:16:application call to "construct" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:43:50:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v708 = v707.addr;
  const v709 = v707.addr2;
  const v710 = v707.addr3;
  const v711 = v707.addr4;
  const v712 = v707.addr5;
  const v713 = v707.amt;
  const v714 = v707.tok;
  const v715 = v707.token_name;
  const v716 = v707.token_symbol;
  
  const txn1 = await (ctc.sendrecv({
    args: [v708, v709, v710, v711, v712, v713, v714, v715, v716],
    evt_cnt: 9,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    pay: [stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v724
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v730 = v718;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    waitIfNotPresent: false
    }));
  const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
  ;
  ;
  const v730 = v718;
  stdlib.protect(ctc6, await interact.signal(), {
    at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:81:41:application',
    fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:81:19:application call to [unknown function] (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:81:23:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:146:16:application call to "construct" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:43:50:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 1,
    funcNum: 1,
    out_tys: [ctc7],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
  switch (v747[0]) {
    case 'Contractee0_59': {
      const v750 = v747[1];
      ;
      v746;
      const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
      stdlib.assert(v760, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v764 = stdlib.sub(v723, v723);
      ;
      const txn3 = await (ctc.recv({
        didSend: false,
        evt_cnt: 7,
        funcNum: 2,
        out_tys: [ctc2, ctc1, ctc1, ctc1, ctc8, ctc9, ctc1],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
      const v802 = stdlib.tokenEq(v793, v724);
      const v803 = v802 ? false : true;
      stdlib.assert(v803, {
        at: './interface.rsh:144:14:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'non-network tokens distinct',
        who: 'Constructor'
        });
      ;
      const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
      ;
      const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v806, {
        at: './interface.rsh:147:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v807 = stdlib.lt(v795, v794);
      stdlib.assert(v807, {
        at: './interface.rsh:148:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v808 = stdlib.tokenEq(v724, v793);
      const v809 = v808 ? false : true;
      stdlib.assert(v809, {
        at: './interface.rsh:149:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v810, {
        at: './interface.rsh:150:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v811 = v798.reduce((v812, v813) => {
        const v814 = stdlib.add(v812, v813);
        
        return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v815 = stdlib.le(v811, v799);
      stdlib.assert(v815, {
        at: './interface.rsh:151:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
      const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
      const v818 = stdlib.eq(v799, v817);
      stdlib.assert(v818, {
        at: './interface.rsh:152:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
      ;
      const v824 = v792;
      const txn4 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 3,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
      ;
      ;
      const v831 = stdlib.addressEq(v824, v825);
      stdlib.assert(v831, {
        at: './interface.rsh:185:13:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'sender correct',
        who: 'Constructor'
        });
      const v836 = stdlib.sub(v794, v795);
      const v837 = stdlib.sub(v796, v801);
      const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v850 = stdlib.div(v845, v837);
      const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      let v860 = v794;
      let v861 = true;
      let v862 = v826;
      let v865 = v827;
      let v868 = v823;
      let v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
      let v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
      
      while (await (async () => {
        
        return v861;})()) {
        const txn5 = await (ctc.recv({
          didSend: false,
          evt_cnt: 1,
          funcNum: 6,
          out_tys: [ctc11],
          timeoutAt: undefined,
          waitIfNotPresent: false
          }));
        const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn5;
        switch (v909[0]) {
          case 'Bid_acceptOffer0_273': {
            const v912 = v909[1];
            const v918 = stdlib.sub(v865, v801);
            const v919 = stdlib.mul(v918, v850);
            const v920 = stdlib.div(v919, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v922 = stdlib.lt(v920, v836);
            const v923 = v922 ? v920 : v836;
            const v924 = stdlib.le(v794, v923);
            const v925 = stdlib.sub(v794, v923);
            const v926 = v924 ? v795 : v925;
            const v927 = stdlib.gt(v795, v926);
            const v928 = v927 ? v795 : v926;
            const v932 = stdlib.add(v868, v928);
            ;
            undefined;
            const v934 = null;
            await txn5.getOutput('Bid_acceptOffer', 'v934', ctc6, v934);
            const v952 = stdlib.div(v928, v799);
            const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
            const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
            const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
            const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
            const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
            const v962 = stdlib.add(v954, v955);
            const v963 = stdlib.add(v962, v956);
            const v964 = stdlib.add(v963, v957);
            const v965 = stdlib.add(v964, v958);
            const v966 = stdlib.mul(v952, v965);
            const v967 = stdlib.sub(v928, v966);
            const v969 = stdlib.mul(v952, v954);
            const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
            const v974 = stdlib.sub(v932, v969);
            ;
            const v976 = stdlib.mul(v952, v955);
            const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
            const v981 = stdlib.sub(v974, v976);
            ;
            const v985 = stdlib.sub(v981, v967);
            ;
            const v990 = stdlib.sub(v870, v870);
            ;
            const cv860 = v928;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v985;
            const cv869 = v869;
            const cv870 = v990;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_cancel0_273': {
            const v1027 = v909[1];
            ;
            undefined;
            const v1108 = stdlib.addressEq(v908, v792);
            stdlib.assert(v1108, {
              at: './interface.rsh:250:16:application',
              fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Constructor'
              });
            const v1109 = null;
            await txn5.getOutput('Bid_cancel', 'v1109', ctc6, v1109);
            const v1119 = stdlib.sub(v870, v870);
            ;
            const cv860 = v860;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v1119;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_touch0_273': {
            const v1142 = v909[1];
            ;
            undefined;
            const v1237 = stdlib.ge(v860, v795);
            stdlib.assert(v1237, {
              at: './interface.rsh:217:16:application',
              fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Constructor'
              });
            const v1238 = null;
            await txn5.getOutput('Bid_touch', 'v1238', ctc6, v1238);
            const v1245 = stdlib.sub(v865, v801);
            const v1246 = stdlib.mul(v1245, v850);
            const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v1249 = stdlib.lt(v1247, v836);
            const v1250 = v1249 ? v1247 : v836;
            const v1251 = stdlib.le(v794, v1250);
            const v1252 = stdlib.sub(v794, v1250);
            const v1253 = v1251 ? v795 : v1252;
            const v1254 = stdlib.gt(v795, v1253);
            const v1255 = v1254 ? v795 : v1253;
            const cv860 = v1255;
            const cv861 = true;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v870;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          }
        
        }
      const txn5 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 5,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
      ;
      const v1261 = stdlib.div(v860, v799);
      const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v1269 = stdlib.add(v1263, v1264);
      const v1270 = stdlib.add(v1269, v1265);
      const v1272 = stdlib.mul(v1261, v1270);
      const v1273 = stdlib.sub(v868, v1272);
      const v1275 = stdlib.mul(v1261, v1263);
      const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
      ;
      const v1282 = stdlib.mul(v1261, v1264);
      const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
      ;
      const v1289 = stdlib.mul(v1261, v1265);
      const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
      ;
      const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
      ;
      ;
      ;
      return;
      
      
      
      
      
      
      
      break;
      }
    case 'Verifier0_59': {
      const v1327 = v747[1];
      ;
      const v1896 = stdlib.addressEq(v746, v730);
      stdlib.assert(v1896, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
      const v1898 = stdlib.addressEq(v746, v718);
      const v1899 = v1897 ? v1898 : false;
      stdlib.assert(v1899, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Constructor'
        });
      return;
      
      break;
      }
    }
  
  
  
  };
export async function Contractee(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Contractee expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Contractee expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 32));
  const ctc4 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8));
  const ctc5 = stdlib.T_Data({
    Contractee0_59: ctc1,
    Verifier0_59: ctc1
    });
  const ctc6 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc7 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc8 = stdlib.T_Tuple([]);
  const ctc9 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc8,
    Bid_cancel0_273: ctc8,
    Bid_touch0_273: ctc8
    });
  const ctc10 = stdlib.T_Null;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 9,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
  ;
  ;
  const v730 = v718;
  const v744 = ['Contractee0_59', stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:115:12:decimal', stdlib.UInt_max, 2)];
  
  const txn2 = await (ctc.sendrecv({
    args: [v718, v719, v723, v724, v730, v744],
    evt_cnt: 1,
    funcNum: 1,
    lct: v727,
    onlyIf: true,
    out_tys: [ctc5],
    pay: [v723, []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
      
      switch (v747[0]) {
        case 'Contractee0_59': {
          const v750 = v747[1];
          sim_r.txns.push({
            amt: v723,
            kind: 'to',
            tok: undefined
            });
          ctc.iam(v746);
          const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
          stdlib.assert(v760, {
            at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
            fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
            msg: null,
            who: 'Contractee'
            });
          const v764 = stdlib.sub(v723, v723);
          sim_r.txns.push({
            amt: v723,
            kind: 'from',
            to: v718,
            tok: undefined
            });
          sim_r.isHalt = false;
          
          break;
          }
        case 'Verifier0_59': {
          const v1327 = v747[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:106:13:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1896 = stdlib.addressEq(v746, v730);
          stdlib.assert(v1896, {
            at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
            fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
            msg: null,
            who: 'Contractee'
            });
          const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
          const v1898 = stdlib.addressEq(v746, v718);
          const v1899 = v1897 ? v1898 : false;
          stdlib.assert(v1899, {
            at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
            fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
            msg: null,
            who: 'Contractee'
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v724
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc1, ctc2, ctc0, ctc5],
    waitIfNotPresent: false
    }));
  const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
  switch (v747[0]) {
    case 'Contractee0_59': {
      const v750 = v747[1];
      ;
      ctc.iam(v746);
      const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
      stdlib.assert(v760, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v764 = stdlib.sub(v723, v723);
      ;
      const txn3 = await (ctc.recv({
        didSend: false,
        evt_cnt: 7,
        funcNum: 2,
        out_tys: [ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
      const v802 = stdlib.tokenEq(v793, v724);
      const v803 = v802 ? false : true;
      stdlib.assert(v803, {
        at: './interface.rsh:144:14:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'non-network tokens distinct',
        who: 'Contractee'
        });
      ;
      const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
      ;
      const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v806, {
        at: './interface.rsh:147:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v807 = stdlib.lt(v795, v794);
      stdlib.assert(v807, {
        at: './interface.rsh:148:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v808 = stdlib.tokenEq(v724, v793);
      const v809 = v808 ? false : true;
      stdlib.assert(v809, {
        at: './interface.rsh:149:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v810, {
        at: './interface.rsh:150:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v811 = v798.reduce((v812, v813) => {
        const v814 = stdlib.add(v812, v813);
        
        return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v815 = stdlib.le(v811, v799);
      stdlib.assert(v815, {
        at: './interface.rsh:151:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
      const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
      const v818 = stdlib.eq(v799, v817);
      stdlib.assert(v818, {
        at: './interface.rsh:152:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
      ;
      const v824 = v792;
      const txn4 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 3,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
      ;
      ;
      const v831 = stdlib.addressEq(v824, v825);
      stdlib.assert(v831, {
        at: './interface.rsh:185:13:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'sender correct',
        who: 'Contractee'
        });
      const v836 = stdlib.sub(v794, v795);
      const v837 = stdlib.sub(v796, v801);
      const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v850 = stdlib.div(v845, v837);
      const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      let v860 = v794;
      let v861 = true;
      let v862 = v826;
      let v865 = v827;
      let v868 = v823;
      let v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
      let v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
      
      while (await (async () => {
        
        return v861;})()) {
        const txn5 = await (ctc.recv({
          didSend: false,
          evt_cnt: 1,
          funcNum: 6,
          out_tys: [ctc9],
          timeoutAt: undefined,
          waitIfNotPresent: false
          }));
        const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn5;
        switch (v909[0]) {
          case 'Bid_acceptOffer0_273': {
            const v912 = v909[1];
            const v918 = stdlib.sub(v865, v801);
            const v919 = stdlib.mul(v918, v850);
            const v920 = stdlib.div(v919, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v922 = stdlib.lt(v920, v836);
            const v923 = v922 ? v920 : v836;
            const v924 = stdlib.le(v794, v923);
            const v925 = stdlib.sub(v794, v923);
            const v926 = v924 ? v795 : v925;
            const v927 = stdlib.gt(v795, v926);
            const v928 = v927 ? v795 : v926;
            const v932 = stdlib.add(v868, v928);
            ;
            undefined;
            const v934 = null;
            await txn5.getOutput('Bid_acceptOffer', 'v934', ctc10, v934);
            const v952 = stdlib.div(v928, v799);
            const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
            const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
            const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
            const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
            const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
            const v962 = stdlib.add(v954, v955);
            const v963 = stdlib.add(v962, v956);
            const v964 = stdlib.add(v963, v957);
            const v965 = stdlib.add(v964, v958);
            const v966 = stdlib.mul(v952, v965);
            const v967 = stdlib.sub(v928, v966);
            const v969 = stdlib.mul(v952, v954);
            const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
            const v974 = stdlib.sub(v932, v969);
            ;
            const v976 = stdlib.mul(v952, v955);
            const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
            const v981 = stdlib.sub(v974, v976);
            ;
            const v985 = stdlib.sub(v981, v967);
            ;
            const v990 = stdlib.sub(v870, v870);
            ;
            const cv860 = v928;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v985;
            const cv869 = v869;
            const cv870 = v990;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_cancel0_273': {
            const v1027 = v909[1];
            ;
            undefined;
            const v1108 = stdlib.addressEq(v908, v792);
            stdlib.assert(v1108, {
              at: './interface.rsh:250:16:application',
              fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Contractee'
              });
            const v1109 = null;
            await txn5.getOutput('Bid_cancel', 'v1109', ctc10, v1109);
            const v1119 = stdlib.sub(v870, v870);
            ;
            const cv860 = v860;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v1119;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_touch0_273': {
            const v1142 = v909[1];
            ;
            undefined;
            const v1237 = stdlib.ge(v860, v795);
            stdlib.assert(v1237, {
              at: './interface.rsh:217:16:application',
              fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Contractee'
              });
            const v1238 = null;
            await txn5.getOutput('Bid_touch', 'v1238', ctc10, v1238);
            const v1245 = stdlib.sub(v865, v801);
            const v1246 = stdlib.mul(v1245, v850);
            const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v1249 = stdlib.lt(v1247, v836);
            const v1250 = v1249 ? v1247 : v836;
            const v1251 = stdlib.le(v794, v1250);
            const v1252 = stdlib.sub(v794, v1250);
            const v1253 = v1251 ? v795 : v1252;
            const v1254 = stdlib.gt(v795, v1253);
            const v1255 = v1254 ? v795 : v1253;
            const cv860 = v1255;
            const cv861 = true;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v870;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          }
        
        }
      const txn5 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 5,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
      ;
      const v1261 = stdlib.div(v860, v799);
      const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v1269 = stdlib.add(v1263, v1264);
      const v1270 = stdlib.add(v1269, v1265);
      const v1272 = stdlib.mul(v1261, v1270);
      const v1273 = stdlib.sub(v868, v1272);
      const v1275 = stdlib.mul(v1261, v1263);
      const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
      ;
      const v1282 = stdlib.mul(v1261, v1264);
      const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
      ;
      const v1289 = stdlib.mul(v1261, v1265);
      const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
      ;
      const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
      ;
      ;
      ;
      return;
      
      
      
      
      
      
      
      break;
      }
    case 'Verifier0_59': {
      const v1327 = v747[1];
      ;
      const v1896 = stdlib.addressEq(v746, v730);
      stdlib.assert(v1896, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
      const v1898 = stdlib.addressEq(v746, v718);
      const v1899 = v1897 ? v1898 : false;
      stdlib.assert(v1899, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Contractee'
        });
      return;
      
      break;
      }
    }
  
  
  
  };
export async function Depositer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Depositer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Depositer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 32));
  const ctc4 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8));
  const ctc5 = stdlib.T_Data({
    Contractee0_59: ctc1,
    Verifier0_59: ctc1
    });
  const ctc6 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc7 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc8 = stdlib.T_Null;
  const ctc9 = stdlib.T_Tuple([]);
  const ctc10 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc9,
    Bid_cancel0_273: ctc9,
    Bid_touch0_273: ctc9
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 9,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
  ;
  ;
  const v730 = v718;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 1,
    funcNum: 1,
    out_tys: [ctc5],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
  switch (v747[0]) {
    case 'Contractee0_59': {
      const v750 = v747[1];
      ;
      v746;
      const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
      stdlib.assert(v760, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v764 = stdlib.sub(v723, v723);
      ;
      const txn3 = await (ctc.recv({
        didSend: false,
        evt_cnt: 7,
        funcNum: 2,
        out_tys: [ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
      const v802 = stdlib.tokenEq(v793, v724);
      const v803 = v802 ? false : true;
      stdlib.assert(v803, {
        at: './interface.rsh:144:14:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'non-network tokens distinct',
        who: 'Depositer'
        });
      ;
      const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
      ;
      const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v806, {
        at: './interface.rsh:147:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v807 = stdlib.lt(v795, v794);
      stdlib.assert(v807, {
        at: './interface.rsh:148:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v808 = stdlib.tokenEq(v724, v793);
      const v809 = v808 ? false : true;
      stdlib.assert(v809, {
        at: './interface.rsh:149:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v810, {
        at: './interface.rsh:150:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v811 = v798.reduce((v812, v813) => {
        const v814 = stdlib.add(v812, v813);
        
        return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v815 = stdlib.le(v811, v799);
      stdlib.assert(v815, {
        at: './interface.rsh:151:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
      const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
      const v818 = stdlib.eq(v799, v817);
      stdlib.assert(v818, {
        at: './interface.rsh:152:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
      ;
      const v824 = ctc.iam(v792);
      const txn4 = await (ctc.sendrecv({
        args: [v724, v792, v793, v794, v795, v796, v797, v798, v799, v801, v823, v824],
        evt_cnt: 0,
        funcNum: 3,
        lct: v800,
        onlyIf: true,
        out_tys: [],
        pay: [stdlib.checkedBigNumberify('./interface.rsh:185:13:dot', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1), v793]]],
        sim_p: (async (txn4) => {
          const sim_r = { txns: [], mapRefs: [], maps: [] };
          
          const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
          
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:185:13:dot', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1),
            kind: 'to',
            tok: v793
            });
          const v831 = stdlib.addressEq(v824, v825);
          stdlib.assert(v831, {
            at: './interface.rsh:185:13:dot',
            fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
            msg: 'sender correct',
            who: 'Depositer'
            });
          
          
          const v836 = stdlib.sub(v794, v795);
          const v837 = stdlib.sub(v796, v801);
          const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
          const v850 = stdlib.div(v845, v837);
          const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
          const v860 = v794;
          const v861 = true;
          const v862 = v826;
          const v865 = v827;
          const v868 = v823;
          const v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
          const v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
          
          if (await (async () => {
            
            return v861;})()) {
            sim_r.isHalt = false;
            }
          else {
            sim_r.isHalt = false;
            }
          return sim_r;
          }),
        soloSend: true,
        timeoutAt: undefined,
        tys: [ctc2, ctc0, ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1, ctc1, ctc1, ctc0],
        waitIfNotPresent: false
        }));
      const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
      ;
      ;
      const v831 = stdlib.addressEq(v824, v825);
      stdlib.assert(v831, {
        at: './interface.rsh:185:13:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'sender correct',
        who: 'Depositer'
        });
      stdlib.protect(ctc8, await interact.signal(), {
        at: './interface.rsh:188:39:application',
        fs: ['at ./interface.rsh:188:17:application call to [unknown function] (defined at: ./interface.rsh:188:21:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'signal',
        who: 'Depositer'
        });
      
      const v834 = 'Start Auction';
      stdlib.protect(ctc8, await interact.log(v834), {
        at: './interface.rsh:189:39:application',
        fs: ['at ./interface.rsh:189:7:application call to [unknown function] (defined at: ./interface.rsh:189:24:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'log',
        who: 'Depositer'
        });
      
      const v836 = stdlib.sub(v794, v795);
      const v837 = stdlib.sub(v796, v801);
      const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v850 = stdlib.div(v845, v837);
      const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      let v860 = v794;
      let v861 = true;
      let v862 = v826;
      let v865 = v827;
      let v868 = v823;
      let v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
      let v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
      
      while (await (async () => {
        
        return v861;})()) {
        const txn5 = await (ctc.recv({
          didSend: false,
          evt_cnt: 1,
          funcNum: 6,
          out_tys: [ctc10],
          timeoutAt: undefined,
          waitIfNotPresent: false
          }));
        const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn5;
        switch (v909[0]) {
          case 'Bid_acceptOffer0_273': {
            const v912 = v909[1];
            const v918 = stdlib.sub(v865, v801);
            const v919 = stdlib.mul(v918, v850);
            const v920 = stdlib.div(v919, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v922 = stdlib.lt(v920, v836);
            const v923 = v922 ? v920 : v836;
            const v924 = stdlib.le(v794, v923);
            const v925 = stdlib.sub(v794, v923);
            const v926 = v924 ? v795 : v925;
            const v927 = stdlib.gt(v795, v926);
            const v928 = v927 ? v795 : v926;
            const v932 = stdlib.add(v868, v928);
            ;
            undefined;
            const v934 = null;
            await txn5.getOutput('Bid_acceptOffer', 'v934', ctc8, v934);
            const v952 = stdlib.div(v928, v799);
            const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
            const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
            const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
            const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
            const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
            const v962 = stdlib.add(v954, v955);
            const v963 = stdlib.add(v962, v956);
            const v964 = stdlib.add(v963, v957);
            const v965 = stdlib.add(v964, v958);
            const v966 = stdlib.mul(v952, v965);
            const v967 = stdlib.sub(v928, v966);
            const v969 = stdlib.mul(v952, v954);
            const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
            const v974 = stdlib.sub(v932, v969);
            ;
            const v976 = stdlib.mul(v952, v955);
            const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
            const v981 = stdlib.sub(v974, v976);
            ;
            const v985 = stdlib.sub(v981, v967);
            ;
            const v990 = stdlib.sub(v870, v870);
            ;
            const cv860 = v928;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v985;
            const cv869 = v869;
            const cv870 = v990;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_cancel0_273': {
            const v1027 = v909[1];
            ;
            undefined;
            const v1108 = stdlib.addressEq(v908, v792);
            stdlib.assert(v1108, {
              at: './interface.rsh:250:16:application',
              fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Depositer'
              });
            const v1109 = null;
            await txn5.getOutput('Bid_cancel', 'v1109', ctc8, v1109);
            const v1119 = stdlib.sub(v870, v870);
            ;
            const cv860 = v860;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v1119;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_touch0_273': {
            const v1142 = v909[1];
            ;
            undefined;
            const v1237 = stdlib.ge(v860, v795);
            stdlib.assert(v1237, {
              at: './interface.rsh:217:16:application',
              fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Depositer'
              });
            const v1238 = null;
            await txn5.getOutput('Bid_touch', 'v1238', ctc8, v1238);
            const v1245 = stdlib.sub(v865, v801);
            const v1246 = stdlib.mul(v1245, v850);
            const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v1249 = stdlib.lt(v1247, v836);
            const v1250 = v1249 ? v1247 : v836;
            const v1251 = stdlib.le(v794, v1250);
            const v1252 = stdlib.sub(v794, v1250);
            const v1253 = v1251 ? v795 : v1252;
            const v1254 = stdlib.gt(v795, v1253);
            const v1255 = v1254 ? v795 : v1253;
            const cv860 = v1255;
            const cv861 = true;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v870;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          }
        
        }
      const txn5 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 5,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
      ;
      const v1261 = stdlib.div(v860, v799);
      const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v1269 = stdlib.add(v1263, v1264);
      const v1270 = stdlib.add(v1269, v1265);
      const v1272 = stdlib.mul(v1261, v1270);
      const v1273 = stdlib.sub(v868, v1272);
      const v1275 = stdlib.mul(v1261, v1263);
      const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
      ;
      const v1282 = stdlib.mul(v1261, v1264);
      const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
      ;
      const v1289 = stdlib.mul(v1261, v1265);
      const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
      ;
      const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
      ;
      ;
      ;
      return;
      
      
      
      
      
      
      
      break;
      }
    case 'Verifier0_59': {
      const v1327 = v747[1];
      ;
      const v1896 = stdlib.addressEq(v746, v730);
      stdlib.assert(v1896, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
      const v1898 = stdlib.addressEq(v746, v718);
      const v1899 = v1897 ? v1898 : false;
      stdlib.assert(v1899, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Depositer'
        });
      return;
      
      break;
      }
    }
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 32));
  const ctc4 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8));
  const ctc5 = stdlib.T_Data({
    Contractee0_59: ctc1,
    Verifier0_59: ctc1
    });
  const ctc6 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc7 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc8 = stdlib.T_Tuple([]);
  const ctc9 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc8,
    Bid_cancel0_273: ctc8,
    Bid_touch0_273: ctc8
    });
  const ctc10 = stdlib.T_Null;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 9,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
  ;
  ;
  const v730 = v718;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 1,
    funcNum: 1,
    out_tys: [ctc5],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
  switch (v747[0]) {
    case 'Contractee0_59': {
      const v750 = v747[1];
      ;
      v746;
      const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
      stdlib.assert(v760, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v764 = stdlib.sub(v723, v723);
      ;
      const txn3 = await (ctc.recv({
        didSend: false,
        evt_cnt: 7,
        funcNum: 2,
        out_tys: [ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
      const v802 = stdlib.tokenEq(v793, v724);
      const v803 = v802 ? false : true;
      stdlib.assert(v803, {
        at: './interface.rsh:144:14:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'non-network tokens distinct',
        who: 'Relay'
        });
      ;
      const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
      ;
      const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v806, {
        at: './interface.rsh:147:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v807 = stdlib.lt(v795, v794);
      stdlib.assert(v807, {
        at: './interface.rsh:148:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v808 = stdlib.tokenEq(v724, v793);
      const v809 = v808 ? false : true;
      stdlib.assert(v809, {
        at: './interface.rsh:149:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v810, {
        at: './interface.rsh:150:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v811 = v798.reduce((v812, v813) => {
        const v814 = stdlib.add(v812, v813);
        
        return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v815 = stdlib.le(v811, v799);
      stdlib.assert(v815, {
        at: './interface.rsh:151:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
      const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
      const v818 = stdlib.eq(v799, v817);
      stdlib.assert(v818, {
        at: './interface.rsh:152:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
      ;
      const v824 = v792;
      const txn4 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 3,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
      ;
      ;
      const v831 = stdlib.addressEq(v824, v825);
      stdlib.assert(v831, {
        at: './interface.rsh:185:13:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'sender correct',
        who: 'Relay'
        });
      const v836 = stdlib.sub(v794, v795);
      const v837 = stdlib.sub(v796, v801);
      const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v850 = stdlib.div(v845, v837);
      const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      let v860 = v794;
      let v861 = true;
      let v862 = v826;
      let v865 = v827;
      let v868 = v823;
      let v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
      let v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
      
      while (await (async () => {
        
        return v861;})()) {
        const txn5 = await (ctc.recv({
          didSend: false,
          evt_cnt: 1,
          funcNum: 6,
          out_tys: [ctc9],
          timeoutAt: undefined,
          waitIfNotPresent: false
          }));
        const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn5;
        switch (v909[0]) {
          case 'Bid_acceptOffer0_273': {
            const v912 = v909[1];
            const v918 = stdlib.sub(v865, v801);
            const v919 = stdlib.mul(v918, v850);
            const v920 = stdlib.div(v919, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v922 = stdlib.lt(v920, v836);
            const v923 = v922 ? v920 : v836;
            const v924 = stdlib.le(v794, v923);
            const v925 = stdlib.sub(v794, v923);
            const v926 = v924 ? v795 : v925;
            const v927 = stdlib.gt(v795, v926);
            const v928 = v927 ? v795 : v926;
            const v932 = stdlib.add(v868, v928);
            ;
            undefined;
            const v934 = null;
            await txn5.getOutput('Bid_acceptOffer', 'v934', ctc10, v934);
            const v952 = stdlib.div(v928, v799);
            const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
            const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
            const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
            const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
            const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
            const v962 = stdlib.add(v954, v955);
            const v963 = stdlib.add(v962, v956);
            const v964 = stdlib.add(v963, v957);
            const v965 = stdlib.add(v964, v958);
            const v966 = stdlib.mul(v952, v965);
            const v967 = stdlib.sub(v928, v966);
            const v969 = stdlib.mul(v952, v954);
            const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
            const v974 = stdlib.sub(v932, v969);
            ;
            const v976 = stdlib.mul(v952, v955);
            const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
            const v981 = stdlib.sub(v974, v976);
            ;
            const v985 = stdlib.sub(v981, v967);
            ;
            const v990 = stdlib.sub(v870, v870);
            ;
            const cv860 = v928;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v985;
            const cv869 = v869;
            const cv870 = v990;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_cancel0_273': {
            const v1027 = v909[1];
            ;
            undefined;
            const v1108 = stdlib.addressEq(v908, v792);
            stdlib.assert(v1108, {
              at: './interface.rsh:250:16:application',
              fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Relay'
              });
            const v1109 = null;
            await txn5.getOutput('Bid_cancel', 'v1109', ctc10, v1109);
            const v1119 = stdlib.sub(v870, v870);
            ;
            const cv860 = v860;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v1119;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_touch0_273': {
            const v1142 = v909[1];
            ;
            undefined;
            const v1237 = stdlib.ge(v860, v795);
            stdlib.assert(v1237, {
              at: './interface.rsh:217:16:application',
              fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Relay'
              });
            const v1238 = null;
            await txn5.getOutput('Bid_touch', 'v1238', ctc10, v1238);
            const v1245 = stdlib.sub(v865, v801);
            const v1246 = stdlib.mul(v1245, v850);
            const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v1249 = stdlib.lt(v1247, v836);
            const v1250 = v1249 ? v1247 : v836;
            const v1251 = stdlib.le(v794, v1250);
            const v1252 = stdlib.sub(v794, v1250);
            const v1253 = v1251 ? v795 : v1252;
            const v1254 = stdlib.gt(v795, v1253);
            const v1255 = v1254 ? v795 : v1253;
            const cv860 = v1255;
            const cv861 = true;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v870;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          }
        
        }
      const txn5 = await (ctc.sendrecv({
        args: [v724, v793, v794, v795, v796, v797, v798, v799, v859, v860, v868, v869, v870],
        evt_cnt: 0,
        funcNum: 5,
        lct: v862,
        onlyIf: true,
        out_tys: [],
        pay: [stdlib.checkedBigNumberify('./interface.rsh:259:9:decimal', stdlib.UInt_max, 0), []],
        sim_p: (async (txn5) => {
          const sim_r = { txns: [], mapRefs: [], maps: [] };
          
          const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
          
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./interface.rsh:259:9:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1261 = stdlib.div(v860, v799);
          const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
          const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
          const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
          const v1269 = stdlib.add(v1263, v1264);
          const v1270 = stdlib.add(v1269, v1265);
          const v1272 = stdlib.mul(v1261, v1270);
          const v1273 = stdlib.sub(v868, v1272);
          const v1275 = stdlib.mul(v1261, v1263);
          const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
          sim_r.txns.push({
            amt: v1275,
            kind: 'from',
            to: v1276,
            tok: undefined
            });
          const v1282 = stdlib.mul(v1261, v1264);
          const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
          sim_r.txns.push({
            amt: v1282,
            kind: 'from',
            to: v1283,
            tok: undefined
            });
          const v1289 = stdlib.mul(v1261, v1265);
          const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
          sim_r.txns.push({
            amt: v1289,
            kind: 'from',
            to: v1290,
            tok: undefined
            });
          const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: v1273,
            kind: 'from',
            to: v1295,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v870,
            kind: 'from',
            to: v1295,
            tok: v793
            });
          sim_r.txns.push({
            amt: v869,
            kind: 'from',
            to: v1295,
            tok: v724
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v793
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v724
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          
          return sim_r;
          }),
        soloSend: true,
        timeoutAt: undefined,
        tys: [ctc2, ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1],
        waitIfNotPresent: false
        }));
      const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
      ;
      const v1261 = stdlib.div(v860, v799);
      const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v1269 = stdlib.add(v1263, v1264);
      const v1270 = stdlib.add(v1269, v1265);
      const v1272 = stdlib.mul(v1261, v1270);
      const v1273 = stdlib.sub(v868, v1272);
      const v1275 = stdlib.mul(v1261, v1263);
      const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
      ;
      const v1282 = stdlib.mul(v1261, v1264);
      const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
      ;
      const v1289 = stdlib.mul(v1261, v1265);
      const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
      ;
      const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
      ;
      ;
      ;
      return;
      
      
      
      
      
      
      
      break;
      }
    case 'Verifier0_59': {
      const v1327 = v747[1];
      ;
      const v1896 = stdlib.addressEq(v746, v730);
      stdlib.assert(v1896, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Relay'
        });
      const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
      const v1898 = stdlib.addressEq(v746, v718);
      const v1899 = v1897 ? v1898 : false;
      stdlib.assert(v1899, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Relay'
        });
      return;
      
      break;
      }
    }
  
  
  
  };
export async function Verifier(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Verifier expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Verifier expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 32));
  const ctc4 = stdlib.T_Bytes(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 8));
  const ctc5 = stdlib.T_Data({
    Contractee0_59: ctc1,
    Verifier0_59: ctc1
    });
  const ctc6 = stdlib.T_Array(ctc0, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc7 = stdlib.T_Array(ctc1, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 5));
  const ctc8 = stdlib.T_Tuple([]);
  const ctc9 = stdlib.T_Data({
    Bid_acceptOffer0_273: ctc8,
    Bid_cancel0_273: ctc8,
    Bid_touch0_273: ctc8
    });
  const ctc10 = stdlib.T_Null;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 9,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc2, ctc3, ctc4],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v718, v719, v720, v721, v722, v723, v724, v725, v726], secs: v728, time: v727, didSend: v52, from: v717 } = txn1;
  ;
  ;
  const v730 = ctc.iam(v718);
  const v745 = ['Verifier0_59', stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:103:12:decimal', stdlib.UInt_max, 1)];
  
  const txn2 = await (ctc.sendrecv({
    args: [v718, v719, v723, v724, v730, v745],
    evt_cnt: 1,
    funcNum: 1,
    lct: v727,
    onlyIf: true,
    out_tys: [ctc5],
    pay: [stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:106:13:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
      
      switch (v747[0]) {
        case 'Contractee0_59': {
          const v750 = v747[1];
          sim_r.txns.push({
            amt: v723,
            kind: 'to',
            tok: undefined
            });
          v746;
          const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
          stdlib.assert(v760, {
            at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
            fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
            msg: null,
            who: 'Verifier'
            });
          const v764 = stdlib.sub(v723, v723);
          sim_r.txns.push({
            amt: v723,
            kind: 'from',
            to: v718,
            tok: undefined
            });
          sim_r.isHalt = false;
          
          break;
          }
        case 'Verifier0_59': {
          const v1327 = v747[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:106:13:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1896 = stdlib.addressEq(v746, v730);
          stdlib.assert(v1896, {
            at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
            fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
            msg: null,
            who: 'Verifier'
            });
          const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
          const v1898 = stdlib.addressEq(v746, v718);
          const v1899 = v1897 ? v1898 : false;
          stdlib.assert(v1899, {
            at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
            fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
            msg: null,
            who: 'Verifier'
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v724
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc1, ctc2, ctc0, ctc5],
    waitIfNotPresent: false
    }));
  const {data: [v747], secs: v749, time: v748, didSend: v115, from: v746 } = txn2;
  switch (v747[0]) {
    case 'Contractee0_59': {
      const v750 = v747[1];
      ;
      v746;
      const v760 = stdlib.eq(v750, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:20:decimal', stdlib.UInt_max, 2));
      stdlib.assert(v760, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:120:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v764 = stdlib.sub(v723, v723);
      ;
      const txn3 = await (ctc.recv({
        didSend: false,
        evt_cnt: 7,
        funcNum: 2,
        out_tys: [ctc2, ctc1, ctc1, ctc1, ctc6, ctc7, ctc1],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [v793, v794, v795, v796, v797, v798, v799], secs: v801, time: v800, didSend: v179, from: v792 } = txn3;
      const v802 = stdlib.tokenEq(v793, v724);
      const v803 = v802 ? false : true;
      stdlib.assert(v803, {
        at: './interface.rsh:144:14:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'non-network tokens distinct',
        who: 'Verifier'
        });
      ;
      const v805 = stdlib.add(v764, stdlib.checkedBigNumberify('./interface.rsh:145:5:decimal', stdlib.UInt_max, 100000));
      ;
      const v806 = stdlib.gt(v795, stdlib.checkedBigNumberify('./interface.rsh:147:24:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v806, {
        at: './interface.rsh:147:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v807 = stdlib.lt(v795, v794);
      stdlib.assert(v807, {
        at: './interface.rsh:148:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v808 = stdlib.tokenEq(v724, v793);
      const v809 = v808 ? false : true;
      stdlib.assert(v809, {
        at: './interface.rsh:149:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v810 = stdlib.gt(v796, stdlib.checkedBigNumberify('./interface.rsh:150:21:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v810, {
        at: './interface.rsh:150:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v811 = v798.reduce((v812, v813) => {
        const v814 = stdlib.add(v812, v813);
        
        return v814;}, stdlib.checkedBigNumberify('reach standard library:143:19:decimal', stdlib.UInt_max, 0))
      const v815 = stdlib.le(v811, v799);
      stdlib.assert(v815, {
        at: './interface.rsh:151:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v816 = stdlib.mul(stdlib.checkedBigNumberify('./interface.rsh:152:25:decimal', stdlib.UInt_max, 10), v795);
      const v817 = stdlib.div(v816, stdlib.checkedBigNumberify('./interface.rsh:152:43:decimal', stdlib.UInt_max, 1000000));
      const v818 = stdlib.eq(v799, v817);
      stdlib.assert(v818, {
        at: './interface.rsh:152:10:application',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v823 = stdlib.sub(v805, stdlib.checkedBigNumberify('./interface.rsh:179:12:decimal', stdlib.UInt_max, 100000));
      ;
      const v824 = v792;
      const txn4 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 3,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v827, time: v826, didSend: v213, from: v825 } = txn4;
      ;
      ;
      const v831 = stdlib.addressEq(v824, v825);
      stdlib.assert(v831, {
        at: './interface.rsh:185:13:dot',
        fs: ['at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
        msg: 'sender correct',
        who: 'Verifier'
        });
      const v836 = stdlib.sub(v794, v795);
      const v837 = stdlib.sub(v796, v801);
      const v845 = stdlib.mul(v836, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      const v850 = stdlib.div(v845, v837);
      const v859 = stdlib.div(v850, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
      let v860 = v794;
      let v861 = true;
      let v862 = v826;
      let v865 = v827;
      let v868 = v823;
      let v869 = stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:63:6:dot', stdlib.UInt_max, 0);
      let v870 = stdlib.checkedBigNumberify('./interface.rsh:185:19:decimal', stdlib.UInt_max, 1);
      
      while (await (async () => {
        
        return v861;})()) {
        const txn5 = await (ctc.recv({
          didSend: false,
          evt_cnt: 1,
          funcNum: 6,
          out_tys: [ctc9],
          timeoutAt: undefined,
          waitIfNotPresent: false
          }));
        const {data: [v909], secs: v911, time: v910, didSend: v469, from: v908 } = txn5;
        switch (v909[0]) {
          case 'Bid_acceptOffer0_273': {
            const v912 = v909[1];
            const v918 = stdlib.sub(v865, v801);
            const v919 = stdlib.mul(v918, v850);
            const v920 = stdlib.div(v919, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v922 = stdlib.lt(v920, v836);
            const v923 = v922 ? v920 : v836;
            const v924 = stdlib.le(v794, v923);
            const v925 = stdlib.sub(v794, v923);
            const v926 = v924 ? v795 : v925;
            const v927 = stdlib.gt(v795, v926);
            const v928 = v927 ? v795 : v926;
            const v932 = stdlib.add(v868, v928);
            ;
            undefined;
            const v934 = null;
            await txn5.getOutput('Bid_acceptOffer', 'v934', ctc10, v934);
            const v952 = stdlib.div(v928, v799);
            const v954 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 0)];
            const v955 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 1)];
            const v956 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
            const v957 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
            const v958 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
            const v962 = stdlib.add(v954, v955);
            const v963 = stdlib.add(v962, v956);
            const v964 = stdlib.add(v963, v957);
            const v965 = stdlib.add(v964, v958);
            const v966 = stdlib.mul(v952, v965);
            const v967 = stdlib.sub(v928, v966);
            const v969 = stdlib.mul(v952, v954);
            const v970 = v797[stdlib.checkedBigNumberify('./interface.rsh:238:47:array ref', stdlib.UInt_max, 0)];
            const v974 = stdlib.sub(v932, v969);
            ;
            const v976 = stdlib.mul(v952, v955);
            const v977 = v797[stdlib.checkedBigNumberify('./interface.rsh:239:47:array ref', stdlib.UInt_max, 1)];
            const v981 = stdlib.sub(v974, v976);
            ;
            const v985 = stdlib.sub(v981, v967);
            ;
            const v990 = stdlib.sub(v870, v870);
            ;
            const cv860 = v928;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v985;
            const cv869 = v869;
            const cv870 = v990;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_cancel0_273': {
            const v1027 = v909[1];
            ;
            undefined;
            const v1108 = stdlib.addressEq(v908, v792);
            stdlib.assert(v1108, {
              at: './interface.rsh:250:16:application',
              fs: ['at ./interface.rsh:249:11:application call to [unknown function] (defined at: ./interface.rsh:249:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Verifier'
              });
            const v1109 = null;
            await txn5.getOutput('Bid_cancel', 'v1109', ctc10, v1109);
            const v1119 = stdlib.sub(v870, v870);
            ;
            const cv860 = v860;
            const cv861 = false;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v1119;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          case 'Bid_touch0_273': {
            const v1142 = v909[1];
            ;
            undefined;
            const v1237 = stdlib.ge(v860, v795);
            stdlib.assert(v1237, {
              at: './interface.rsh:217:16:application',
              fs: ['at ./interface.rsh:216:11:application call to [unknown function] (defined at: ./interface.rsh:216:11:function exp)', 'at ./index.rsh:18:6:application call to "App" (defined at: ./interface.rsh:119:26:function exp)'],
              msg: null,
              who: 'Verifier'
              });
            const v1238 = null;
            await txn5.getOutput('Bid_touch', 'v1238', ctc10, v1238);
            const v1245 = stdlib.sub(v865, v801);
            const v1246 = stdlib.mul(v1245, v850);
            const v1247 = stdlib.div(v1246, stdlib.checkedBigNumberify('./interface.rsh:17:19:decimal', stdlib.UInt_max, 1000000));
            const v1249 = stdlib.lt(v1247, v836);
            const v1250 = v1249 ? v1247 : v836;
            const v1251 = stdlib.le(v794, v1250);
            const v1252 = stdlib.sub(v794, v1250);
            const v1253 = v1251 ? v795 : v1252;
            const v1254 = stdlib.gt(v795, v1253);
            const v1255 = v1254 ? v795 : v1253;
            const cv860 = v1255;
            const cv861 = true;
            const cv862 = v910;
            const cv865 = v911;
            const cv868 = v868;
            const cv869 = v869;
            const cv870 = v870;
            
            v860 = cv860;
            v861 = cv861;
            v862 = cv862;
            v865 = cv865;
            v868 = cv868;
            v869 = cv869;
            v870 = cv870;
            
            continue;
            break;
            }
          }
        
        }
      const txn5 = await (ctc.recv({
        didSend: false,
        evt_cnt: 0,
        funcNum: 5,
        out_tys: [],
        timeoutAt: undefined,
        waitIfNotPresent: false
        }));
      const {data: [], secs: v1259, time: v1258, didSend: v606, from: v1257 } = txn5;
      ;
      const v1261 = stdlib.div(v860, v799);
      const v1263 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 2)];
      const v1264 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 3)];
      const v1265 = v798[stdlib.checkedBigNumberify('reach standard library:576:31:array ref', stdlib.UInt_max, 4)];
      const v1269 = stdlib.add(v1263, v1264);
      const v1270 = stdlib.add(v1269, v1265);
      const v1272 = stdlib.mul(v1261, v1270);
      const v1273 = stdlib.sub(v868, v1272);
      const v1275 = stdlib.mul(v1261, v1263);
      const v1276 = v797[stdlib.checkedBigNumberify('./interface.rsh:265:41:array ref', stdlib.UInt_max, 2)];
      ;
      const v1282 = stdlib.mul(v1261, v1264);
      const v1283 = v797[stdlib.checkedBigNumberify('./interface.rsh:266:41:array ref', stdlib.UInt_max, 3)];
      ;
      const v1289 = stdlib.mul(v1261, v1265);
      const v1290 = v797[stdlib.checkedBigNumberify('./interface.rsh:267:41:array ref', stdlib.UInt_max, 4)];
      ;
      const v1295 = v797[stdlib.checkedBigNumberify('./interface.rsh:268:32:array ref', stdlib.UInt_max, 0)];
      ;
      ;
      ;
      return;
      
      
      
      
      
      
      
      break;
      }
    case 'Verifier0_59': {
      const v1327 = v747[1];
      ;
      const v1896 = stdlib.addressEq(v746, v730);
      stdlib.assert(v1896, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:99:7:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      const v1897 = stdlib.eq(v1327, stdlib.checkedBigNumberify('./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:20:decimal', stdlib.UInt_max, 1));
      const v1898 = stdlib.addressEq(v746, v718);
      const v1899 = v1897 ? v1898 : false;
      stdlib.assert(v1899, {
        at: './.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:108:14:application',
        fs: ['at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:147:13:application call to "binaryFork" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:98:45:function exp)', 'at ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:172:31:application call to "verify" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:131:59:function exp)', 'at ./index.rsh:18:21:application call to "useConstructor" (defined at: ./.reach/rev/@github.com:nash-protocol:starter-kit:5d32b2723f73936276aa2c4a1856ad806dd78257/util.rsh:166:100:function exp)'],
        msg: null,
        who: 'Verifier'
        });
      return;
      
      break;
      }
    }
  
  
  
  };
const _ALGO = {
  appApproval: `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`,
  appClear: `BYEA`,
  extraPages: 1,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 3,
  stateSize: 352,
  unsupported: [],
  version: 8
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v718",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v719",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v720",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v721",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v722",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v723",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v724",
                "type": "address"
              },
              {
                "components": [
                  {
                    "internalType": "bytes32",
                    "name": "elem0",
                    "type": "bytes32"
                  }
                ],
                "internalType": "struct T7",
                "name": "v725",
                "type": "tuple"
              },
              {
                "components": [
                  {
                    "internalType": "bytes8",
                    "name": "elem0",
                    "type": "bytes8"
                  }
                ],
                "internalType": "struct T8",
                "name": "v726",
                "type": "tuple"
              }
            ],
            "internalType": "struct T9",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T10",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v718",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v719",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v720",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v721",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v722",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v723",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v724",
                "type": "address"
              },
              {
                "components": [
                  {
                    "internalType": "bytes32",
                    "name": "elem0",
                    "type": "bytes32"
                  }
                ],
                "internalType": "struct T7",
                "name": "v725",
                "type": "tuple"
              },
              {
                "components": [
                  {
                    "internalType": "bytes8",
                    "name": "elem0",
                    "type": "bytes8"
                  }
                ],
                "internalType": "struct T8",
                "name": "v726",
                "type": "tuple"
              }
            ],
            "internalType": "struct T9",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T10",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T11",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "uint256",
                    "name": "_Contractee0_59",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "_Verifier0_59",
                    "type": "uint256"
                  }
                ],
                "internalType": "struct T11",
                "name": "v747",
                "type": "tuple"
              }
            ],
            "internalType": "struct T12",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v793",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v794",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v795",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v796",
                "type": "uint256"
              },
              {
                "internalType": "address payable[5]",
                "name": "v797",
                "type": "address[5]"
              },
              {
                "internalType": "uint256[5]",
                "name": "v798",
                "type": "uint256[5]"
              },
              {
                "internalType": "uint256",
                "name": "v799",
                "type": "uint256"
              }
            ],
            "internalType": "struct T14",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T15",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e2",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T20",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e3",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T20",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e5",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T22",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_acceptOffer0_273",
                    "type": "bool"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_cancel0_273",
                    "type": "bool"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_touch0_273",
                    "type": "bool"
                  }
                ],
                "internalType": "struct T22",
                "name": "v909",
                "type": "tuple"
              }
            ],
            "internalType": "struct T23",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T24",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e6",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1109",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1238",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v934",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endSecs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_floorPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_priceChangePerSec",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_startPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Bid_acceptOffer",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Bid_cancel",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Bid_touch",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T11",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "uint256",
                    "name": "_Contractee0_59",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "_Verifier0_59",
                    "type": "uint256"
                  }
                ],
                "internalType": "struct T11",
                "name": "v747",
                "type": "tuple"
              }
            ],
            "internalType": "struct T12",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v793",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v794",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v795",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v796",
                "type": "uint256"
              },
              {
                "internalType": "address payable[5]",
                "name": "v797",
                "type": "address[5]"
              },
              {
                "internalType": "uint256[5]",
                "name": "v798",
                "type": "uint256[5]"
              },
              {
                "internalType": "uint256",
                "name": "v799",
                "type": "uint256"
              }
            ],
            "internalType": "struct T14",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T15",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T20",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m3",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T20",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m5",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T22",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_acceptOffer0_273",
                    "type": "bool"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_cancel0_273",
                    "type": "bool"
                  },
                  {
                    "internalType": "bool",
                    "name": "_Bid_touch0_273",
                    "type": "bool"
                  }
                ],
                "internalType": "struct T22",
                "name": "v909",
                "type": "tuple"
              }
            ],
            "internalType": "struct T23",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T24",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m6",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `0x6080604052604051620050f6380380620050f683398101604081905262000026916200033e565b60008080554360035560408051602081018252918252517f31ef34def932070996f0526ea24e0060eada8fb5b8676b9f7e72b76146f00181906200006c90849062000433565b60405180910390a1620000823415600e6200014f565b60208281018051516001600160a01b0390811684526040805160a080820183526000808352828701818152838501828152606080860184815260808088018681528b51518b16808a528c518e01518c1687528c5189015186529b5160c0908101518c1684528e518c168252600197889055439097558951808e019c909c5294518a168b8a01529251918a01919091525187169088015251909416858201528251808603909101815293909201905281519092620001459260029291019062000179565b5050505062000531565b81620001755760405163100960cb60e01b81526004810182905260240160405180910390fd5b5050565b8280546200018790620004f4565b90600052602060002090601f016020900481019282620001ab5760008555620001f6565b82601f10620001c657805160ff1916838001178555620001f6565b82800160010185558215620001f6579182015b82811115620001f6578251825591602001919060010190620001d9565b506200020492915062000208565b5090565b5b8082111562000204576000815560010162000209565b604051602081016001600160401b03811182821017156200025057634e487b7160e01b600052604160045260246000fd5b60405290565b604080519081016001600160401b03811182821017156200025057634e487b7160e01b600052604160045260246000fd5b60405161012081016001600160401b03811182821017156200025057634e487b7160e01b600052604160045260246000fd5b80516001600160a01b0381168114620002d157600080fd5b919050565b600060208284031215620002e957600080fd5b620002f36200021f565b9151825250919050565b6000602082840312156200031057600080fd5b6200031a6200021f565b82519091506001600160c01b0319811681146200033657600080fd5b815292915050565b60008183036101408112156200035357600080fd5b6200035d62000256565b8351815261012080601f19840112156200037657600080fd5b6200038062000287565b92506200039060208601620002b9565b8352620003a060408601620002b9565b6020840152620003b360608601620002b9565b6040840152620003c660808601620002b9565b6060840152620003d960a08601620002b9565b608084015260c085015160a0840152620003f660e08601620002b9565b60c08401526101006200040c87828801620002d6565b60e08501526200041f87838801620002fd565b908401525060208101919091529392505050565b8151815260208083015180516001600160a01b039081168385015291810151821660408085019190915281015191821660608401526101408301915060608101516001600160a01b03811660808501525060808101516001600160a01b03811660a08501525060a081015160c084015260c0810151620004be60e08501826001600160a01b03169052565b5060e0810151610100620004d481860183519052565b919091015180516001600160c01b03191661012085015290505092915050565b600181811c908216806200050957607f821691505b602082108114156200052b57634e487b7160e01b600052602260045260246000fd5b50919050565b614bb580620005416000396000f3fe6080604052600436106101005760003560e01c80638047e42f1161008f578063c9f7f82e11610061578063c9f7f82e14610259578063cef2c0981461026e578063d12e31f714610283578063d336c06914610298578063ef8d9cf8146102ad57005b80638047e42f146101e1578063832307571461020e5780638e31476914610223578063ab53f2c61461023657005b80633ccbd570116100d35780633ccbd5701461016c5780636af5f0e2146101815780636d2001d91461019657806373b4522c146101a9578063793354f4146101bc57005b806236c367146101095780630388052b1461011c578063145c9c85146101445780631e93b0f11461015757005b3661010757005b005b610107610117366004613d3a565b6102c2565b34801561012857600080fd5b506101316102fb565b6040519081526020015b60405180910390f35b610107610152366004613d52565b6106a9565b34801561016357600080fd5b50600354610131565b34801561017857600080fd5b506101316106de565b34801561018d57600080fd5b50610131610a77565b6101076101a4366004613d64565b610e06565b6101076101b7366004613d77565b610e3b565b3480156101c857600080fd5b506101d1610e70565b604051901515815260200161013b565b3480156101ed57600080fd5b506101f6610edc565b6040516001600160a01b03909116815260200161013b565b34801561021a57600080fd5b50600154610131565b610107610231366004613d77565b611275565b34801561024257600080fd5b5061024b6112aa565b60405161013b929190613db5565b34801561026557600080fd5b50610131611347565b34801561027a57600080fd5b506101d16116cc565b34801561028f57600080fd5b506101d161173c565b3480156102a457600080fd5b506101316117ac565b3480156102b957600080fd5b506101d1611b57565b60408051606081018252600080825260208201819052918101919091526102f76102f136849003840184613f34565b82611eee565b5050565b6000600160005414156103b85760006002805461031790613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461034390613fd5565b80156103905780601f1061036557610100808354040283529160200191610390565b820191906000526020600020905b81548152906001019060200180831161037357829003601f168201915b50505050508060200190518101906103a8919061402f565b90506103b66000600b61282d565b505b60026000541415610473576000600280546103d290613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546103fe90613fd5565b801561044b5780601f106104205761010080835404028352916020019161044b565b820191906000526020600020905b81548152906001019060200180831161042e57829003601f168201915b505050505080602001905181019061046391906140be565b90506104716000600b61282d565b505b6003600054141561052e5760006002805461048d90613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546104b990613fd5565b80156105065780601f106104db57610100808354040283529160200191610506565b820191906000526020600020905b8154815290600101906020018083116104e957829003601f168201915b505050505080602001905181019061051e91906141c7565b905061052c6000600b61282d565b505b600560005414156105e45760006002805461054890613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461057490613fd5565b80156105c15780601f10610596576101008083540402835291602001916105c1565b820191906000526020600020905b8154815290600101906020018083116105a457829003601f168201915b50505050508060200190518101906105d9919061428f565b610100015192915050565b6007600054141561069a576000600280546105fe90613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461062a90613fd5565b80156106775780601f1061064c57610100808354040283529160200191610677565b820191906000526020600020905b81548152906001019060200180831161065a57829003601f168201915b505050505080602001905181019061068f9190614356565b610180015192915050565b6106a66000600b61282d565b90565b60408051606081018252600080825260208201819052918101919091526102f76106d836849003840184614463565b82612853565b60006001600054141561079b576000600280546106fa90613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461072690613fd5565b80156107735780601f1061074857610100808354040283529160200191610773565b820191906000526020600020905b81548152906001019060200180831161075657829003601f168201915b505050505080602001905181019061078b919061402f565b90506107996000600961282d565b505b60026000541415610856576000600280546107b590613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546107e190613fd5565b801561082e5780601f106108035761010080835404028352916020019161082e565b820191906000526020600020905b81548152906001019060200180831161081157829003601f168201915b505050505080602001905181019061084691906140be565b90506108546000600961282d565b505b6003600054141561090b5760006002805461087090613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461089c90613fd5565b80156108e95780601f106108be576101008083540402835291602001916108e9565b820191906000526020600020905b8154815290600101906020018083116108cc57829003601f168201915b505050505080602001905181019061090191906141c7565b60a0015192915050565b600560005414156109c05760006002805461092590613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461095190613fd5565b801561099e5780601f106109735761010080835404028352916020019161099e565b820191906000526020600020905b81548152906001019060200180831161098157829003601f168201915b50505050508060200190518101906109b6919061428f565b6080015192915050565b60076000541415610a6b576000600280546109da90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610a0690613fd5565b8015610a535780601f10610a2857610100808354040283529160200191610a53565b820191906000526020600020905b815481529060010190602001808311610a3657829003601f168201915b50505050508060200190518101906109019190614356565b6106a66000600961282d565b600060016000541415610b3457600060028054610a9390613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610abf90613fd5565b8015610b0c5780601f10610ae157610100808354040283529160200191610b0c565b820191906000526020600020905b815481529060010190602001808311610aef57829003601f168201915b5050505050806020019051810190610b24919061402f565b9050610b326000600a61282d565b505b60026000541415610bef57600060028054610b4e90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610b7a90613fd5565b8015610bc75780601f10610b9c57610100808354040283529160200191610bc7565b820191906000526020600020905b815481529060010190602001808311610baa57829003601f168201915b5050505050806020019051810190610bdf91906140be565b9050610bed6000600a61282d565b505b60036000541415610c9a57600060028054610c0990613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610c3590613fd5565b8015610c825780601f10610c5757610100808354040283529160200191610c82565b820191906000526020600020905b815481529060010190602001808311610c6557829003601f168201915b50505050508060200190518101906109b691906141c7565b60056000541415610d4f57600060028054610cb490613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610ce090613fd5565b8015610d2d5780601f10610d0257610100808354040283529160200191610d2d565b820191906000526020600020905b815481529060010190602001808311610d1057829003601f168201915b5050505050806020019051810190610d45919061428f565b6060015192915050565b60076000541415610dfa57600060028054610d6990613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610d9590613fd5565b8015610de25780601f10610db757610100808354040283529160200191610de2565b820191906000526020600020905b815481529060010190602001808311610dc557829003601f168201915b50505050508060200190518101906109b69190614356565b6106a66000600a61282d565b60408051606081018252600080825260208201819052918101919091526102f7610e3536849003840184614542565b82612b47565b60408051606081018252600080825260208201819052918101919091526102f7610e6a3684900384018461462c565b82612f4d565b60408051606081018252600080825260208201819052918101829052610e94613952565b604080516080810182526000808252602080830182905282840182905260608301919091528251808201909352818352830191909152610ed48284611eee565b505051919050565b600060016000541415610f9957600060028054610ef890613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610f2490613fd5565b8015610f715780601f10610f4657610100808354040283529160200191610f71565b820191906000526020600020905b815481529060010190602001808311610f5457829003601f168201915b5050505050806020019051810190610f89919061402f565b9050610f976000600d61282d565b505b6002600054141561105457600060028054610fb390613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054610fdf90613fd5565b801561102c5780601f106110015761010080835404028352916020019161102c565b820191906000526020600020905b81548152906001019060200180831161100f57829003601f168201915b505050505080602001905181019061104491906140be565b90506110526000600d61282d565b505b600360005414156111095760006002805461106e90613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461109a90613fd5565b80156110e75780601f106110bc576101008083540402835291602001916110e7565b820191906000526020600020905b8154815290600101906020018083116110ca57829003601f168201915b50505050508060200190518101906110ff91906141c7565b6040015192915050565b600560005414156111be5760006002805461112390613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461114f90613fd5565b801561119c5780601f106111715761010080835404028352916020019161119c565b820191906000526020600020905b81548152906001019060200180831161117f57829003601f168201915b50505050508060200190518101906111b4919061428f565b6020015192915050565b60076000541415611269576000600280546111d890613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461120490613fd5565b80156112515780601f1061122657610100808354040283529160200191611251565b820191906000526020600020905b81548152906001019060200180831161123457829003601f168201915b50505050508060200190518101906110ff9190614356565b6106a66000600d61282d565b60408051606081018252600080825260208201819052918101919091526102f76112a43684900384018461462c565b82613214565b6000606060005460028080546112bf90613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546112eb90613fd5565b80156113385780601f1061130d57610100808354040283529160200191611338565b820191906000526020600020905b81548152906001019060200180831161131b57829003601f168201915b50505050509050915091509091565b6000600160005414156114045760006002805461136390613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461138f90613fd5565b80156113dc5780601f106113b1576101008083540402835291602001916113dc565b820191906000526020600020905b8154815290600101906020018083116113bf57829003601f168201915b50505050508060200190518101906113f4919061402f565b90506114026000600c61282d565b505b600260005414156114bf5760006002805461141e90613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461144a90613fd5565b80156114975780601f1061146c57610100808354040283529160200191611497565b820191906000526020600020905b81548152906001019060200180831161147a57829003601f168201915b50505050508060200190518101906114af91906140be565b90506114bd6000600c61282d565b505b6003600054141561156a576000600280546114d990613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461150590613fd5565b80156115525780601f1061152757610100808354040283529160200191611552565b820191906000526020600020905b81548152906001019060200180831161153557829003601f168201915b5050505050806020019051810190610d4591906141c7565b600560005414156116155760006002805461158490613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546115b090613fd5565b80156115fd5780601f106115d2576101008083540402835291602001916115fd565b820191906000526020600020905b8154815290600101906020018083116115e057829003601f168201915b50505050508060200190518101906110ff919061428f565b600760005414156116c05760006002805461162f90613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461165b90613fd5565b80156116a85780601f1061167d576101008083540402835291602001916116a8565b820191906000526020600020905b81548152906001019060200180831161168b57829003601f168201915b5050505050806020019051810190610d459190614356565b6106a66000600c61282d565b604080516060810182526000808252602082018190529181018290526116f0613952565b604080516080810182526000602080830182905282840182905260608301919091526001825282518082019093528183528301919091526117318284611eee565b505060200151919050565b60408051606081018252600080825260208201819052918101829052611760613952565b604080516080810182526000602080830182905282840182905260608301919091526002825282518082019093528183528301919091526117a18284611eee565b505060400151919050565b600060016000541415611869576000600280546117c890613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546117f490613fd5565b80156118415780601f1061181657610100808354040283529160200191611841565b820191906000526020600020905b81548152906001019060200180831161182457829003601f168201915b5050505050806020019051810190611859919061402f565b90506118676000600861282d565b505b600260005414156119245760006002805461188390613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546118af90613fd5565b80156118fc5780601f106118d1576101008083540402835291602001916118fc565b820191906000526020600020905b8154815290600101906020018083116118df57829003601f168201915b505050505080602001905181019061191491906140be565b90506119226000600861282d565b505b600360005414156119df5760006002805461193e90613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461196a90613fd5565b80156119b75780601f1061198c576101008083540402835291602001916119b7565b820191906000526020600020905b81548152906001019060200180831161199a57829003601f168201915b50505050508060200190518101906119cf91906141c7565b90506119dd6000600861282d565b505b60056000541415611a95576000600280546119f990613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611a2590613fd5565b8015611a725780601f10611a4757610100808354040283529160200191611a72565b820191906000526020600020905b815481529060010190602001808311611a5557829003601f168201915b5050505050806020019051810190611a8a919061428f565b610120015192915050565b60076000541415611b4b57600060028054611aaf90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611adb90613fd5565b8015611b285780601f10611afd57610100808354040283529160200191611b28565b820191906000526020600020905b815481529060010190602001808311611b0b57829003601f168201915b5050505050806020019051810190611b409190614356565b6101a0015192915050565b6106a66000600861282d565b600060016000541415611c1457600060028054611b7390613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611b9f90613fd5565b8015611bec5780601f10611bc157610100808354040283529160200191611bec565b820191906000526020600020905b815481529060010190602001808311611bcf57829003601f168201915b5050505050806020019051810190611c04919061402f565b9050611c126000600761282d565b505b60026000541415611ccf57600060028054611c2e90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611c5a90613fd5565b8015611ca75780601f10611c7c57610100808354040283529160200191611ca7565b820191906000526020600020905b815481529060010190602001808311611c8a57829003601f168201915b5050505050806020019051810190611cbf91906140be565b9050611ccd6000600761282d565b505b60036000541415611d8357600060028054611ce990613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611d1590613fd5565b8015611d625780601f10611d3757610100808354040283529160200191611d62565b820191906000526020600020905b815481529060010190602001808311611d4557829003601f168201915b5050505050806020019051810190611d7a91906141c7565b50600092915050565b60056000541415611e3757600060028054611d9d90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611dc990613fd5565b8015611e165780601f10611deb57610100808354040283529160200191611e16565b820191906000526020600020905b815481529060010190602001808311611df957829003601f168201915b5050505050806020019051810190611e2e919061428f565b50600192915050565b60076000541415611ee257600060028054611e5190613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611e7d90613fd5565b8015611eca5780601f10611e9f57610100808354040283529160200191611eca565b820191906000526020600020905b815481529060010190602001808311611ead57829003601f168201915b5050505050806020019051810190611d7a9190614356565b6106a66000600761282d565b611efe600760005414602d61282d565b8151611f19901580611f1257508251600154145b602e61282d565b600080805560028054611f2b90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054611f5790613fd5565b8015611fa45780601f10611f7957610100808354040283529160200191611fa4565b820191906000526020600020905b815481529060010190602001808311611f8757829003601f168201915b5050505050806020019051810190611fbc9190614356565b905061201b60405180610160016040528060008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b7f65ba3c52e9aacb57f14951ed6b2e6d6482045474161df5f26ea357744bd0e7cd8460405161204a9190614698565b60405180910390a1600060208501515151600281111561206c5761206c614682565b141561244f57620f4240826101600151836101200151846101c001516120929190614702565b61209c9190614719565b6120a69190614738565b808252610140830151116120bf578161014001516120c2565b80515b60208201819052606083015111156120ed57806020015182606001516120e89190614702565b6120f3565b81608001515b6040820181905260808301511161210e578060400151612114565b81608001515b60608201819052612128903414602861282d565b604051600181527ffd94339b5550d300ab0d4313d98e14b00b6f5f1f4fcd25fb87d326d2e4343ae69060200160405180910390a16001835261010082015160608201516121759190614738565b60808281019190915260e08301519081015160608201516040830151602084015193519293919290916121a791614770565b6121b19190614770565b6121bb9190614770565b6121c59190614770565b81608001516121d49190614719565b81606001516121e39190614702565b60a082015260e08201515160808201516121fd9190614719565b60c0828101829052830151516040516001600160a01b039091169180156108fc02916000818181858888f1935050505015801561223e573d6000803e3d6000fd5b5060e08201516020015160808201516122579190614719565b60e0820181905260c0830151602001516040516001600160a01b039091169180156108fc02916000818181858888f1935050505015801561229c573d6000803e3d6000fd5b5081602001516001600160a01b03166108fc8260a001519081150290604051600060405180830381858888f193505050501580156122de573d6000803e3d6000fd5b506122f3826040015133846102200151613535565b6122fb613997565b825181516001600160a01b0391821690526020808501518351908316908201526040808601518451931692810192909252606080860151845182015260808087015185519091015260a080870151855182015260c080880151865182015260e0808901518751820152610100808a0151885190910152610120808a0151885190910152610140808a0151885190910152610160808a0151885190910152610180808a0151885190910152878401805186890180519190915280516000970196909652855143970196909652935142930192909252850151918501519085015192516101e0870151929391926123f09190614770565b6123fa9190614702565b6124049190614702565b61240e9190614702565b60208201805160800191909152610200840151905160a001526102208301516124379080614702565b602082015160c001526124498161354e565b50612827565b600160208501515151600281111561246957612469614682565b14156125f65761247b3415602961282d565b61249e82602001516001600160a01b0316336001600160a01b031614602a61282d565b604051600181527f66e3ecc81737f06d1e17e1950ceb88773e8eb7d24d2f26ffc859eb00e389b76d9060200160405180910390a16001602084015260408201516102208301516124f091903390613535565b6124f8613997565b825181516001600160a01b03918216905260208085015183519083169082015260408086015184519316928101929092526060808601518451820152608080870151855182015260a080880151865182015260c08089015187519091015260e08089015187519091015261010080890151875190910152610120808901518751909101526101408089015187519091015261016080890151875190910152610180808901518751909101526101a0880151848701805191909152805160009501949094528351439501949094528251429201919091526101e08601518251909101526102008501519051909101526102208301516124379080614702565b600260208501515151600281111561261057612610614682565b1415612827576126223415602b61282d565b6126398260800151836101a001511015602c61282d565b604051600181527fefc0233325d4a63854ba3378407cbea7c660f89f933e9571b281a59fa22a4f379060200160405180910390a1600160408401526101608201516101208301516101c0840151620f4240929161269591614702565b61269f9190614719565b6126a99190614738565b6101008201819052610140830151116126c7578161014001516126ce565b8061010001515b6101208201819052606083015111156126fb5780610120015182606001516126f69190614702565b612701565b81608001515b61014082015261270f613997565b825181516001600160a01b0391821690526020808501518351908316910152604080850151835192169101526060808401518251909101526080808401805183519092019190915260a08085015183519091015260c08085015183519091015260e080850151835190910152610100808501518351909101526101208085015183519091015261014080850151835182015261016080860151845190910152610180808601518451909101528301519051116127d0578161014001516127d6565b82608001515b6020808301805192909252815160019101528051436040909101528051426060909101526101e0840151815160800152610200840151815160a00152610220840151905160c001526124498161354e565b50505050565b816102f75760405163100960cb60e01b8152600481018290526024015b60405180910390fd5b612863600160005414601461282d565b815161287e90158061287757508251600154145b601561282d565b60008080556002805461289090613fd5565b80601f01602080910402602001604051908101604052809291908181526020018280546128bc90613fd5565b80156129095780601f106128de57610100808354040283529160200191612909565b820191906000526020600020905b8154815290600101906020018083116128ec57829003601f168201915b5050505050806020019051810190612921919061402f565b905061294760405180606001604052806000815260200160008152602001600081525090565b7f0ba6ef113ede74aca8f2e2ffc914e9041fdf8b493228a62412e804737dd451cf846040516129769190614788565b60405180910390a1600060208501515151600181111561299857612998614682565b1415612aa257602080850151510151815260408201516129bb903414600f61282d565b80516129cb90600214601061282d565b60408201516129da9080614702565b6020820152815160408084015190516001600160a01b039092169181156108fc0291906000818181858888f19350505050158015612a1c573d6000803e3d6000fd5b50604080516060808201835260008083526020808401828152848601838152888301516001600160a01b039081168088528a87015182168452898501518352600295869055436001558851808601919091529251168288015251818501528551808203909401845260800190945281519293612a9b93919201906139f1565b5050612827565b6001602085015151516001811115612abc57612abc614682565b14156128275760208401515160409081015190820152612ade3415601161282d565b612b0182608001516001600160a01b0316336001600160a01b031614601261282d565b612b2c6001826040015114612b17576000612b25565b82516001600160a01b031633145b601361282d565b60008080556001819055612b4290600290613a75565b612827565b612b57600260005414601e61282d565b8151612b72901580612b6b57508251600154145b601f61282d565b600080805560028054612b8490613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054612bb090613fd5565b8015612bfd5780601f10612bd257610100808354040283529160200191612bfd565b820191906000526020600020905b815481529060010190602001808311612be057829003601f168201915b5050505050806020019051810190612c1591906140be565b9050612c526040518060a001604052806000815260200160008152602001600081526020016000815260200160006001600160a01b031681525090565b7f57bbf1d00f4e480b220ebfc2a12fba412535753b9b89a7f6dccd8e3e2207603684604051612c81919061481b565b60405180910390a1612cc282602001516001600160a01b03168560200151600001516001600160a01b031614612cb8576001612cbb565b60005b601661282d565b612cd2620186a03414601761282d565b612ce8600085602001516040015111601861282d565b612d0584602001516020015185602001516040015110601961282d565b612d3e8460200151600001516001600160a01b031683602001516001600160a01b031614612d34576001612d37565b60005b601a61282d565b612d54600085602001516060015111601b61282d565b6000602082018190525b6005811015612db757846020015160a001518160058110612d8157612d8161475a565b602090810291909101516040840181905290830151612da09190614770565b602083015280612daf81614893565b915050612d5e565b506020808201518083529085015160c00151612dd6911115601c61282d565b612e0d620f4240856020015160400151600a612df29190614719565b612dfc9190614738565b856020015160c0015114601d61282d565b620186a0808360400151612e219190614770565b612e2b9190614702565b606082015281516040516001600160a01b0390911690600090620186a09082818181858883f19350505050158015612e67573d6000803e3d6000fd5b50336080820152612e76613aaf565b6020808401516001600160a01b0390811683523383830152868201805151821660408086019190915281518401516060808701919091528251820151608080880191909152835182015160a080890191909152845182015160c0808a019190915285519091015160e0890152935190930151610100870152426101208701528601516101408601529085015190911661016084015260036000554360015551612f21918391016148ae565b60405160208183030381529060405260029080519060200190612f459291906139f1565b505050505050565b612f5d600360005414602361282d565b8151612f78901580612f7157508251600154145b602461282d565b600080805560028054612f8a90613fd5565b80601f0160208091040260200160405190810160405280929190818152602001828054612fb690613fd5565b80156130035780601f10612fd857610100808354040283529160200191613003565b820191906000526020600020905b815481529060010190602001808311612fe657829003601f168201915b505050505080602001905181019061301b91906141c7565b905061303a604051806040016040528060008152602001600081525090565b60408051855181526020808701511515908201527f25e9400ad0fddc8c71fc4eb2845b4d0fc13ca66f2a17e1b7e0f544d275234c09910160405180910390a16130853415602061282d565b61309f6130983384604001516001613754565b602161282d565b6101608201516130bb906001600160a01b03163314602261282d565b816080015182606001516130cf9190614702565b815261012082015160a08301516130e69190614702565b81516130f690620f424090614719565b6131009190614738565b602082015261310d613997565b825181516001600160a01b0391821690526020808501518351908316908201526040808601518451931692019190915260608085015183519091015260808085015183519091015260a08085015183519091015260c08085015183519091015260e08085015183519091015261010080850151835190910152610120808501518351909101528251825161014001528201805182516101600152516131b690620f424090614738565b8151610180015260608084015160208084018051929092528151600191018190528151436040909101528151429301929092526101408501518151608001528051600060a0909101525160c0015261320d8161354e565b5050505050565b613224600560005414602661282d565b815161323f90158061323857508251600154145b602761282d565b60008080556002805461325190613fd5565b80601f016020809104026020016040519081016040528092919081815260200182805461327d90613fd5565b80156132ca5780601f1061329f576101008083540402835291602001916132ca565b820191906000526020600020905b8154815290600101906020018083116132ad57829003601f168201915b50505050508060200190518101906132e2919061428f565b90506132fa6040518060200160405280600081525090565b60408051855181526020808701511515908201527f9cdba579557d44a893ea7929682d6795d48dd5c40dc981d852842d4b18914de8910160405180910390a16133453415602561282d565b8160e0015182610120015161335a9190614738565b80825260a083015160409081015160c0850151909101516001600160a01b03909116916108fc9161338a91614719565b6040518115909202916000818181858888f193505050501580156133b2573d6000803e3d6000fd5b5060a08201516060015160c08301516001600160a01b03909116906108fc906003602002015183516133e49190614719565b6040518115909202916000818181858888f1935050505015801561340c573d6000803e3d6000fd5b5060a08201516080015160c08301516001600160a01b03909116906108fc9060046020020151835161343e9190614719565b6040518115909202916000818181858888f19350505050158015613466573d6000803e3d6000fd5b5060a08201515160c0830151608081015160608201516040909201516001600160a01b03909316926108fc9261349b91614770565b6134a59190614770565b83516134b19190614719565b8461014001516134c19190614702565b6040518115909202916000818181858888f193505050501580156134e9573d6000803e3d6000fd5b50602082015160a083015151610180840151613506929190613535565b815160a08301515161016084015161351f929190613535565b6000808055600181905561282790600290613a75565b61354083838361376c565b61354957600080fd5b505050565b8060200151602001511561368157613564613b40565b8151516001600160a01b0390811682528251602090810151821681840152835160409081015190921682840152835160609081015181850152845160809081015181860152855160a09081015181870152865160c09081015181880152875160e0908101519088015287516101009081015190880152875161012090810151908801528751610140908101519088015287516101609081015190880152875161018090810151908801528488018051516101a08901528051909401516101c08801528351909201516101e08701528251015161020086015290510151610220840152600760005543600155905161365d9183910161497b565b604051602081830303815290604052600290805190602001906135499291906139f1565b613689613bf2565b8151516001600160a01b0390811682528251604090810151909116602080840191909152835160609081015183850152845160809081015191850191909152845160a09081015182860152855160c09081015182870152865160e09081015182880152875161010090810151918801919091528751610180908101519188019190915284880180515161012089015280519094015161014088015283519092015161016087015291519091015190840152600560005543600155905161365d91839101614a8a565b50565b60006137628385308561383d565b90505b9392505050565b604080516001600160a01b038481166024830152604480830185905283518084039091018152606490920183526020820180516001600160e01b031663a9059cbb60e01b1790529151600092839283929188169183916137cb91614b46565b60006040518083038185875af1925050503d8060008114613808576040519150601f19603f3d011682016040523d82523d6000602084013e61380d565b606091505b509150915061381e82826002613917565b50808060200190518101906138339190614b62565b9695505050505050565b604080516001600160a01b0385811660248301528481166044830152606480830185905283518084039091018152608490920183526020820180516001600160e01b03166323b872dd60e01b1790529151600092839283929189169183916138a491614b46565b60006040518083038185875af1925050503d80600081146138e1576040519150601f19603f3d011682016040523d82523d6000602084013e6138e6565b606091505b50915091506138f782826001613917565b508080602001905181019061390c9190614b62565b979650505050505050565b60608315613926575081613765565b8251156139365782518084602001fd5b60405163100960cb60e01b81526004810183905260240161284a565b6040518060400160405280600081526020016139926040805160a08101825260006020820181815292820181905260608201819052608082015290815290565b905290565b60405180604001604052806139aa613c78565b81526020016139926040518060e001604052806000815260200160001515815260200160008152602001600081526020016000815260200160008152602001600081525090565b8280546139fd90613fd5565b90600052602060002090601f016020900481019282613a1f5760008555613a65565b82601f10613a3857805160ff1916838001178555613a65565b82800160010185558215613a65579182015b82811115613a65578251825591602001919060010190613a4a565b50613a71929150613d07565b5090565b508054613a8190613fd5565b6000825580601f10613a91575050565b601f0160209004906000526020600020908101906137519190613d07565b60405180610180016040528060006001600160a01b0316815260200160006001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815260200160008152602001613b08613d1c565b8152602001613b15613d1c565b815260200160008152602001600081526020016000815260200160006001600160a01b031681525090565b60405180610240016040528060006001600160a01b0316815260200160006001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815260200160008152602001613b99613d1c565b8152602001613ba6613d1c565b8152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b604051806101a0016040528060006001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815260200160008152602001613c3b613d1c565b8152602001613c48613d1c565b81526020016000815260200160008152602001600081526020016000815260200160008152602001600081525090565b604051806101a0016040528060006001600160a01b0316815260200160006001600160a01b0316815260200160006001600160a01b03168152602001600081526020016000815260200160008152602001613cd1613d1c565b8152602001613cde613d1c565b815260200160008152602001600081526020016000815260200160008152602001600081525090565b5b80821115613a715760008155600101613d08565b6040518060a001604052806005906020820280368337509192915050565b600060a08284031215613d4c57600080fd5b50919050565b600060808284031215613d4c57600080fd5b60006102008284031215613d4c57600080fd5b600060408284031215613d4c57600080fd5b60005b83811015613da4578181015183820152602001613d8c565b838111156128275750506000910152565b8281526040602082015260008251806040840152613dda816060850160208701613d89565b601f01601f1916919091016060019392505050565b634e487b7160e01b600052604160045260246000fd5b6040805190810167ffffffffffffffff81118282101715613e2857613e28613def565b60405290565b6040516020810167ffffffffffffffff81118282101715613e2857613e28613def565b6040516080810167ffffffffffffffff81118282101715613e2857613e28613def565b604051610180810167ffffffffffffffff81118282101715613e2857613e28613def565b6040516101a0810167ffffffffffffffff81118282101715613e2857613e28613def565b604051610240810167ffffffffffffffff81118282101715613e2857613e28613def565b60405160e0810167ffffffffffffffff81118282101715613e2857613e28613def565b60405160a0810167ffffffffffffffff81118282101715613e2857613e28613def565b801515811461375157600080fd5b600081830360a0811215613f4757600080fd5b613f4f613e05565b833581526080601f1983011215613f6557600080fd5b613f6d613e2e565b9150613f77613e51565b602085013560038110613f8957600080fd5b81526040850135613f9981613f26565b60208201526060850135613fac81613f26565b60408201526080850135613fbf81613f26565b6060820152825260208101919091529392505050565b600181811c90821680613fe957607f821691505b60208210811415613d4c57634e487b7160e01b600052602260045260246000fd5b6001600160a01b038116811461375157600080fd5b805161402a8161400a565b919050565b600060a0828403121561404157600080fd5b60405160a0810181811067ffffffffffffffff8211171561406457614064613def565b60405282516140728161400a565b815260208301516140828161400a565b602082015260408381015190820152606083015161409f8161400a565b606082015260808301516140b28161400a565b60808201529392505050565b6000606082840312156140d057600080fd5b6040516060810181811067ffffffffffffffff821117156140f3576140f3613def565b60405282516141018161400a565b815260208301516141118161400a565b60208201526040928301519281019290925250919050565b600082601f83011261413a57600080fd5b614142613f03565b8060a084018581111561415457600080fd5b845b818110156141775780516141698161400a565b845260209384019301614156565b509095945050505050565b600082601f83011261419357600080fd5b61419b613f03565b8060a08401858111156141ad57600080fd5b845b818110156141775780518452602093840193016141af565b600061028082840312156141da57600080fd5b6141e2613e74565b6141eb8361401f565b81526141f96020840161401f565b602082015261420a6040840161401f565b6040820152606083015160608201526080830151608082015260a083015160a082015261423a8460c08501614129565b60c082015261016061424e85828601614182565b60e0830152610200840151610100830152610220840151610120830152610240840151610140830152614284610260850161401f565b908201529392505050565b60006102a082840312156142a257600080fd5b6142aa613e98565b6142b38361401f565b81526142c16020840161401f565b60208201526040830151604082015260608301516060820152608083015160808201526142f18460a08501614129565b60a082015261014061430585828601614182565b60c08301526101e084015160e0830152610200840151610100830152610220840151610120830152610240840151908201526102608301516101608201526102809092015161018083015250919050565b6000610340828403121561436957600080fd5b614371613ebc565b61437a8361401f565b81526143886020840161401f565b60208201526143996040840161401f565b6040820152606083015160608201526080830151608082015260a083015160a08201526143c98460c08501614129565b60c08201526101606143dd85828601614182565b60e08301526102008085015161010084015261022080860151610120850152610240860151610140850152610260860151838501526102808601516101808501526102a08601516101a08501526102c08601516101c08501526102e08601516101e085015261030086015182850152610320860151818501525050508091505092915050565b6000818303608081121561447657600080fd5b61447e613e05565b833581526060601f198301121561449457600080fd5b61449c613e2e565b91506040516060810181811067ffffffffffffffff821117156144c1576144c1613def565b6040526020850135600281106144d657600080fd5b81526040858101356020808401919091526060909601359082015282529283015250919050565b600082601f83011261450e57600080fd5b614516613f03565b8060a084018581111561452857600080fd5b845b8181101561417757803584526020938401930161452a565b600081830361020081121561455657600080fd5b61455e613e05565b8335815260206101e080601f198501121561457857600080fd5b614580613ee0565b93508186013561458f8161400a565b8085525060408601358285015260608601356040850152608086013560608501528660bf8701126145bf57600080fd5b6145c7613f03565b806101408801898111156145da57600080fd5b60a089015b818110156145ff5780356145f28161400a565b84529285019285016145df565b508160808801526146108a826144fd565b60a0880152505050949094013560c08301529283015250919050565b60006040828403121561463e57600080fd5b6040516040810181811067ffffffffffffffff8211171561466157614661613def565b60405282358152602083013561467681613f26565b60208201529392505050565b634e487b7160e01b600052602160045260246000fd5b81518152602082015151805160a083019190600381106146ba576146ba614682565b806020850152506020810151151560408401526040810151151560608401526060810151151560808401525092915050565b634e487b7160e01b600052601160045260246000fd5b600082821015614714576147146146ec565b500390565b6000816000190483118215151615614733576147336146ec565b500290565b60008261475557634e487b7160e01b600052601260045260246000fd5b500490565b634e487b7160e01b600052603260045260246000fd5b60008219821115614783576147836146ec565b500190565b815181526020820151518051608083019190600281106147aa576147aa614682565b8060208501525060208101516040840152604081015160608401525092915050565b8060005b60058110156128275781516001600160a01b03168452602093840193909101906001016147d0565b8060005b60058110156128275781518452602093840193909101906001016147fc565b60006102008201905082518252602083015160018060a01b038151166020840152602081015160408401526040810151606084015260608101516080840152608081015161486c60a08501826147cc565b5060a08101516148806101408501826147f8565b5060c08101516101e08401525092915050565b60006000198214156148a7576148a76146ec565b5060010190565b81516001600160a01b03168152610280810160208301516148da60208401826001600160a01b03169052565b5060408301516148f560408401826001600160a01b03169052565b50606083015160608301526080830151608083015260a083015160a083015260c083015161492660c08401826147cc565b5060e083015161016061493b818501836147f8565b6101008501516102008501526101208501516102208501526101408501516102408501528401516001600160a01b03811661026085015290505092915050565b81516001600160a01b03168152610340810160208301516149a760208401826001600160a01b03169052565b5060408301516149c260408401826001600160a01b03169052565b50606083015160608301526080830151608083015260a083015160a083015260c08301516149f360c08401826147cc565b5060e0830151610160614a08818501836147f8565b6101008501516102008581019190915261012086015161022080870191909152610140870151610240870152918601516102608601526101808601516102808601526101a08601516102a08601526101c08601516102c08601526101e08601516102e08601528501516103008501529093015161032090920191909152919050565b81516001600160a01b031681526102a081016020830151614ab660208401826001600160a01b03169052565b5060408301516040830152606083015160608301526080830151608083015260a0830151614ae760a08401826147cc565b5060c0830151610140614afc818501836147f8565b60e08501516101e085015261010085015161020085015261012085015161022085015284015161024084015250610160830151610260830152610180909201516102809091015290565b60008251614b58818460208701613d89565b9190910192915050565b600060208284031215614b7457600080fd5b815161376581613f2656fea2646970667358221220483e92a9872b4d3b03f775f1a226a13c0b822f5bb433f307b289805734b4e5bd64736f6c63430008090033`,
  BytecodeLen: 20726,
  Which: `oD`,
  version: 6,
  views: {
    Auction: {
      closed: `Auction_closed`,
      currentPrice: `Auction_currentPrice`,
      endSecs: `Auction_endSecs`,
      floorPrice: `Auction_floorPrice`,
      priceChangePerSec: `Auction_priceChangePerSec`,
      startPrice: `Auction_startPrice`,
      token: `Auction_token`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_acceptOffer": Bid_acceptOffer,
  "Bid_cancel": Bid_cancel,
  "Bid_touch": Bid_touch,
  "Constructor": Constructor,
  "Contractee": Contractee,
  "Depositer": Depositer,
  "Relay": Relay,
  "Verifier": Verifier
  };
export const _APIs = {
  Bid: {
    acceptOffer: Bid_acceptOffer,
    cancel: Bid_cancel,
    touch: Bid_touch
    }
  };
